/*!
 * Javascript Cookie v1.5.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	var jQuery;
	if (typeof define === 'function' && define.amd) {
		// AMD (Register as an anonymous module)
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		try {
			jQuery = require('jquery');
		} catch(e) {}
		module.exports = factory(jQuery);
	} else {
		// Browser globals
		var _OldCookies = window.Cookies;
		var api = window.Cookies = factory(window.jQuery);
		api.noConflict = function() {
			window.Cookies = _OldCookies;
			return api;
		};
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return api.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return api.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(api.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return api.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = api.raw ? s : parseCookieValue(s);
		return isFunction(converter) ? converter(value) : value;
	}

	function extend() {
		var key, options;
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			options = arguments[ i ];
			for (key in options) {
				result[key] = options[key];
			}
		}
		return result;
	}

	function isFunction(obj) {
		return Object.prototype.toString.call(obj) === '[object Function]';
	}

	var api = function (key, value, options) {

		// Write

		if (arguments.length > 1 && !isFunction(value)) {
			options = extend(api.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {},
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()".
			cookies = document.cookie ? document.cookie.split('; ') : [],
			i = 0,
			l = cookies.length;

		for (; i < l; i++) {
			var parts = cookies[i].split('='),
				name = decode(parts.shift()),
				cookie = parts.join('=');

			if (key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	api.get = api.set = api;
	api.defaults = {};

	api.remove = function (key, options) {
		// Must not alter options, thus extending a fresh object...
		api(key, '', extend(options, { expires: -1 }));
		return !api(key);
	};

	if ( $ ) {
		$.cookie = api;
		$.removeCookie = api.remove;
	}

	return api;
}));


if (window.performance && typeof window.performance.mark === 'function') {
  window.performance.mark('mark_i18n_load_start');
}


// I18n.js
// =======
//
// This small library provides the Rails I18n API on the Javascript.
// You don't actually have to use Rails (or even Ruby) to use I18n.js.
// Just make sure you export all translations in an object like this:
//
//     I18n.translations.en = {
//       hello: "Hello World"
//     };
//
// See tests for specific formatting like numbers and dates.
//
// Orignally pulled from https://raw.github.com/fnando/i18n-js/rewrite/app/assets/javascripts/i18n.js
// v3.0.0.rc11 (commit ab4bc2a).
//
// All custom HubSpot modifications are surrounded by comments and have been
// made while the file was in this repo.
//
;(function(I18n){
  "use strict";

  // Just cache the Array#slice function.
  var slice = Array.prototype.slice;

  // Apply number padding.
  var padding = function(number) {
    return ("0" + number.toString()).substr(-2);
  };

  // Set default days/months translations.
  var DATE = {
      day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    , abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    , month_names: [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    , abbr_month_names: [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    , meridian: ["AM", "PM"]
  };

  // Set default number format.
  var NUMBER_FORMAT = {
      precision: 3
    , separator: "."
    , delimiter: ","

    // HACK, HubSpot customizations to default number format
    // (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
    // It would be much nicer if we could change these defaults without having to touch i18n.js (similar to existingOptions?)

    // , strip_insignificant_zeros: false
    , strip_insignificant_zeros: true
    // END HACK
  };

  // Set default currency format.
  var CURRENCY_FORMAT = {
      unit: "$"
    , precision: 2
    , format: "%u%n"
    , sign_first: true
    , delimiter: ","
    , separator: "."
  };

  // Set default percentage format.
  var PERCENTAGE_FORMAT = {
      unit: "%"
    , precision: 3
    , format: "%n%u"
    , separator: "."
    , delimiter: ""
  };

  // Set default size units.
  var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

  // Other default options
  var DEFAULT_OPTIONS = {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
      defaultLocale: "en"
    // Set the current locale to `en`.
    , locale: "en"
    // Set the translation key separator.
    , defaultSeparator: "."
    // Set the placeholder format. Accepts `{placeholder}}` and `%{placeholder}`.}

    // HACK, HubSpot accepts whitespace: `{{ placeholder }}` or `{{placeholder}}` are equivalent
    // , placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm
    , placeholder: /(?:\{\{)\s?(\S*?)\s?(?:\}\})/gm

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    , fallbacks: false
    // Set the default translation object.
    , translations: {}
    // Set missing translation behavior. 'message' will display a message
    // that the translation is missing, 'guess' will try to guess the string
    , missingBehaviour: 'message'
    // if you use missingBehaviour with 'message', but want to know that the
    // string is actually missing for testing purposes, you can prefix the
    // guessed string by setting the value here. By default, no prefix!
    , missingTranslationPrefix: ''
  };

  // Custom HubSpot logic to log key usage
  var keysUsed = {};
  var fallbackKeys = [];
  var keyUsedTimeout;
  var shouldLogUsage = Math.random() <= 0.05;
  function logKeyUsage(key, usedFallbackTranslation, requestedLocaleValue) {
    if (usedFallbackTranslation) {
      try {
        if (localStorage.getItem("TRACK_I18N_FALLBACK_TRANSLATIONS")) {
          var i18nFallbackTranslations = localStorage.getItem("I18N_FALLBACK_TRANSLATIONS");
          if (!i18nFallbackTranslations) {
            i18nFallbackTranslations = key;
          } else {
            i18nFallbackTranslations = i18nFallbackTranslations.concat(',', key);
          }
          localStorage.setItem('I18N_FALLBACK_TRANSLATIONS', i18nFallbackTranslations);
        }
      } catch (e) {}
    }

    if (!shouldLogUsage) {
      return;
    }
    clearTimeout(keyUsedTimeout);

    keysUsed[key] = keysUsed[key] ? keysUsed[key] + 1 : 1;

    if (usedFallbackTranslation && fallbackKeys.indexOf(key) === -1) {
      fallbackKeys.push(key);
    }

    keyUsedTimeout = setTimeout(function() {
      if (window.newrelic) {
        window.newrelic.addPageAction('i18nKeysUsed', {
          keysUsed: JSON.stringify(keysUsed),
          i18nKeyCount: Object.keys(keysUsed).length,
          fallbackKeys: JSON.stringify(fallbackKeys),
          englishFallbackCount: fallbackKeys.length,
          requestedLocaleValue: requestedLocaleValue
        });
      }

      // Don't leak memory if the tab stays open forever.
      shouldLogUsage = false;
      keysUsed = {};
    }, 1000 * 60);
  }
  // End custom HubSpot Logic

  I18n.reset = function() {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
    this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    // Set the current locale to `en`.
    this.locale = DEFAULT_OPTIONS.locale;

    // Set the translation key separator.
    this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
    this.placeholder = DEFAULT_OPTIONS.placeholder;

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    // Set the default translation object.
    this.translations = DEFAULT_OPTIONS.translations;

    // Set the default missing behaviour
    this.missingBehaviour = DEFAULT_OPTIONS.missingBehaviour;

    // Set the default missing string prefix for guess behaviour
    this.missingTranslationPrefix = DEFAULT_OPTIONS.missingTranslationPrefix;

  };

  // Much like `reset`, but only assign options if not already assigned
  I18n.initializeOptions = function() {
    if (typeof(this.defaultLocale) === "undefined" && this.defaultLocale !== null)
      this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    if (typeof(this.locale) === "undefined" && this.locale !== null)
      this.locale = DEFAULT_OPTIONS.locale;

    if (typeof(this.defaultSeparator) === "undefined" && this.defaultSeparator !== null)
      this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    if (typeof(this.placeholder) === "undefined" && this.placeholder !== null)
      this.placeholder = DEFAULT_OPTIONS.placeholder;

    if (typeof(this.fallbacks) === "undefined" && this.fallbacks !== null)
      this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    if (typeof(this.translations) === "undefined" && this.translations !== null)
      this.translations = DEFAULT_OPTIONS.translations;
  };
  I18n.initializeOptions();

  // Return a list of all locales that must be tried before returning the
   // missing translation message. By default, this will consider the inline option,
   // current locale and fallback locale.
   //
   //     I18n.locales.get("de-DE");
   //     // ["de-DE", "de", "en"]
   //
   // You can define custom rules for any locale. Just make sure you return a array
   // containing all locales.
   //
   //     // Default the Wookie locale to English.
   //     I18n.locales["wk"] = function(locale) {
   //       return ["en"];
   //     };
   //
   I18n.locales = {};

   // Retrieve locales based on inline locale, current locale or default to
   // I18n's detection.
   I18n.locales.get = function(locale) {
     var result = this[locale] || this[I18n.locale] || this["default"];

     if (typeof(result) === "function") {
       result = result(locale);
     }

     if (result instanceof Array === false) {
       result = [result];
     }

     return result;
   };

   // The default locale list.
   I18n.locales["default"] = function(locale) {
     var locales = []
       , list = []
       , countryCode
       , count
     ;

     // Handle the inline locale option that can be provided to
     // the `I18n.t` options.
     if (locale) {
       locales.push(locale);
     }

     // Add the current locale to the list.
     if (!locale && I18n.locale) {
       locales.push(I18n.locale);
     }

     // HACK, Handle invalid Norwegian keys
     if (locale === 'noNO' || (!locale && I18n.locale === 'noNO')) {
       locales.push('no-no');
     } else if (locale === 'no-no' || (!locale && I18n.locale === 'no-no')) {
       locales.push('noNO');
     }
     // END HACK

     // Add the default locale if fallback strategy is enabled.
     if (I18n.fallbacks && I18n.defaultLocale) {
       locales.push(I18n.defaultLocale);
     }

     // Compute each locale with its country code.
     // So this will return an array containing both
     // `de-DE` and `de` locales.
     locales.forEach(function(locale){
       countryCode = locale.split("-")[0];

       if (!~list.indexOf(locale)) {
         list.push(locale);
       }

      // HubSpot Hack: Fall back lowercase locales (pt-BR to pt-br) I18n/473
      if (!~list.indexOf(locale.toLowerCase())) {
        list.push(locale.toLowerCase());
      }
      // End Hack

       if (I18n.fallbacks && countryCode && countryCode !== locale && !~list.indexOf(countryCode)) {
         list.push(countryCode);
       }
     });

     // No locales set? English it is.
     if (!locales.length) {
       locales.push("en");
     }

     return list;
   };

  // Hold pluralization rules.
  I18n.pluralization = {};

  // Return the pluralizer for a specific locale.
  // If no specify locale is found, then I18n's default will be used.
  I18n.pluralization.get = function(locale) {
    return this[locale] || this[I18n.locale] || this["default"];
  };

  // The default pluralizer rule.
  // It detects the `zero`, `one`, and `other` scopes.
  I18n.pluralization["default"] = function(count) {
    switch (count) {
      case 0: return ["zero", "other"];

      // HACK, HubSpot customization, more info at https://git.hubteam.com/HubSpot/I18n/commit/c1debccf2409a358b5456830c472ae78ece5e634#commitcomment-8149
      // case 1: return ["one"];
      case 1: return ["one", "other"];
      // END HACK

      default: return ["other"];
    }
  };

  // Return current locale. If no locale has been set, then
  // the current locale will be the default locale.
  I18n.currentLocale = function() {
    return this.locale || this.defaultLocale;
  };

  // Check if value is different than undefined and null;
  I18n.isSet = function(value) {
    return value !== undefined && value !== null;
  };

  // Find and process the translation using the provided scope and options.
  // This is used internally by some functions and should not be used as an
  // public API.
  I18n.lookup = function(scope, options) {
    options = this.prepareOptions(options);

    var locales = this.locales.get(options.locale).slice()
      , requestedLocale = locales[0]
      , locale
      , scopes
      , translations
    ;

    scope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = scope.split(this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }

      while (scopes.length) {
        translations = translations[scopes.shift()];

        if (translations === undefined || translations === null) {
          break;
        }
      }

      var getJustLangValue = function(locale) {
        return locale.split('-')[0];
      }
      var requestedLocaleValue = getJustLangValue(requestedLocale);

      if (translations !== undefined && translations !== null) {
        // HubSpot logic to track key usage and English fallback
        var translationLocaleFound = getJustLangValue(locale);
        var isNotRequestedLocale = requestedLocaleValue !== translationLocaleFound;
        var isFallbackLocale = translationLocaleFound === this.defaultLocale;
        logKeyUsage(scope, this.langEnabled && isNotRequestedLocale && isFallbackLocale, requestedLocaleValue);
        // End HubSpot logic to track English fallback
        return translations;
      }
    }

    // Custom HubSpot logic to log key usage
    logKeyUsage(scope, false, requestedLocaleValue);

    if (this.isSet(options.defaultValue)) {
      return options.defaultValue;
    }
  };

  // Rails changed the way the meridian is stored.
  // It started with `date.meridian` returning an array,
  // then it switched to `time.am` and `time.pm`.
  // This function abstracts this difference and returns
  // the correct meridian or the default value when none is provided.
  I18n.meridian = function() {
    var time = this.lookup("time");
    var date = this.lookup("date");

    if (time && time.am && time.pm) {
      return [time.am, time.pm];
    } else if (date && date.meridian) {
      return date.meridian;
    } else {
      return DATE.meridian;
    }
  };

  // Merge serveral hash options, checking if value is set before
  // overwriting any value. The precedence is from left to right.
  //
  //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
  //     #=> {name: "John Doe", role: "user"}
  //
  I18n.prepareOptions = function() {
    var args = slice.call(arguments)
      , options = {}
      , subject
    ;

    while (args.length) {
      subject = args.shift();

      if (typeof(subject) != "object") {
        continue;
      }

      for (var attr in subject) {
        if (!subject.hasOwnProperty(attr)) {
          continue;
        }

        if (this.isSet(options[attr])) {
          continue;
        }

        options[attr] = subject[attr];
      }
    }

    return options;
  };

  // HACK, HubSpot fix

  // Steal Underscore's isObject implementation to deal with node not correctly respecting
  // `x instanceof Object` across different requires.
  var isObject = function(obj) {
    return obj === Object(obj);
  };

  // END HACK

  // Translate the given scope with the provided options.
  I18n.translate = function(scope, options) {
    options = this.prepareOptions(options);
    var translation = this.lookup(scope, options);

    // HACK: If the translation in this locale is a non-pluralization object, try
    // falling back on the default locale. Otherwise we'd just render "[object Object]"!
    // See HubSpot/I18n#209
    if (isObject(translation) && !this.isSet(options.count)) {
      translation = this.lookup(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
    }
    // END HACK

    if (translation === undefined || translation === null) {
      return this.missingTranslation(scope, options);
    }

    // HACK: Format count param if the translation is not an object
    if (!isObject(translation) && typeof options.count === 'number') {
      options.count = I18n.formatNumber(options.count);
    }
    // END HACK

    if (typeof(translation) === "string") {
      translation = this.interpolate(translation, options);
    // HACK, HubSpot fix
    // } else if (translation instanceof Object && this.isSet(options.count)) {
    } else if (isObject(translation) && this.isSet(options.count)) {
    // END HACK
      translation = this.pluralize(options.count, translation, options);
      // HACK: Fall back on default locale if pluralization failed
      if (translation === undefined && options.locale !== this.defaultLocale) {
        return I18n.translate(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
      }
      // END HACK
    }

    return translation;
  };

  // This function interpolates the all variables in the given message.
  I18n.interpolate = function(message, options) {
    options = this.prepareOptions(options);
    var matches = message.match(this.placeholder)
      , placeholder
      , value
      , name
      , regex
    ;

    if (!matches) {
      return message;
    }

    var value;

    while (matches.length) {
      placeholder = matches.shift();
      name = placeholder.replace(this.placeholder, "$1");

      if (this.isSet(options[name])) {
        value = options[name].toString().replace(/\$/gm, "_#$#_");
      } else if (name in options) {
        // HACK: Pass options through to nullPlaceholder/missingPlaceholder
        // value = this.nullPlaceholder(placeholder, message);
        value = this.nullPlaceholder(placeholder, message, options);
      } else {
        // value = this.missingPlaceholder(placeholder, message);
        value = this.missingPlaceholder(placeholder, message, options);
      }

      regex = new RegExp(placeholder.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
      message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
  };

  // Pluralize the given scope using the `count` value.
  // The pluralized translation may have other placeholders,
  // which will be retrieved from `options`.
  I18n.pluralize = function(count, scope, options) {
    options = this.prepareOptions(options);
    var translations, pluralizer, keys, key, message;

    // HACK, HubSpot fix
    // if (scope instanceof Object) {
    if (isObject(scope)) {
      translations = scope;
    // END HACK
    } else {
      translations = this.lookup(scope, options);
    }

    if (!translations) {
      return this.missingTranslation(scope, options);
    }

    pluralizer = this.pluralization.get(options.locale);
    keys = pluralizer(count);

    while (keys.length) {
      key = keys.shift();

      if (this.isSet(translations[key])) {
        message = translations[key];
        break;
      }
    }

    // HACK, if no translation keys matched then return instead of throwing an error (#303)
    if (typeof message !== 'string') {
      return undefined;
    }
    // END HACK

    // HACK, format count to a localized string instead of just casting it
    // options.count = String(count);
    if (typeof options.count === 'number') {
      options.count = I18n.formatNumber(count);
    }
    // END HACK

    return this.interpolate(message, options);
  };

  // Return a missing translation message for the given parameters.
  I18n.missingTranslation = function(scope, options) {
    //guess intended string
    if(this.missingBehaviour == 'guess'){
      //get only the last portion of the scope
      var s = scope.split('.').slice(-1)[0];
      //replace underscore with space && camelcase with space and lowercase letter
      return (this.missingTranslationPrefix.length > 0 ? this.missingTranslationPrefix : '') +
          s.replace('_',' ').replace(/([a-z])([A-Z])/g,
          function(match, p1, p2) {return p1 + ' ' + p2.toLowerCase()} );
    }

    var fullScope           = this.getFullScope(scope, options);
    var fullScopeWithLocale = [this.currentLocale(), fullScope].join(this.defaultSeparator);

    return '[missing “' + fullScopeWithLocale + '” translation]';
  };

  // Return a missing placeholder message for given parameters
  I18n.missingPlaceholder = function(placeholder, message) {
    return "[missing " + placeholder + " value]";
  };

  I18n.nullPlaceholder = function() {
    return I18n.missingPlaceholder.apply(I18n, arguments);
  };

  // Format number using localization rules.
  // The options will be retrieved from the `number.format` scope.
  // If this isn't present, then the following options will be used:
  //
  // - `precision`: `3`
  // - `separator`: `"."`
  // - `delimiter`: `","`
  // - `strip_insignificant_zeros`: `true`     // HACK, HubSpot customization to make this default to true instead of false (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toNumber = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.format")
      , NUMBER_FORMAT
    );

    var negative = number < 0
      , string = Math.abs(number).toFixed(options.precision).toString()
      , parts = string.split(".")
      , precision
      , buffer = []
      , formattedNumber
      , format = options.format || "%n"
      , sign = negative ? "−" : ""
    ;

    number = parts[0];
    precision = parts[1];

    while (number.length > 0) {
      buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
      number = number.substr(0, number.length -3);
    }

    formattedNumber = buffer.join(options.delimiter);

    if (options.strip_insignificant_zeros && precision) {
      precision = precision.replace(/0+$/, "");
    }

    if (options.precision > 0 && precision) {
      formattedNumber += options.separator + precision;
    }

    if (options.sign_first) {
      format = "%s" + format;
    }
    else {
      format = format.replace("%n", "%s%n");
    }

    formattedNumber = format
      .replace("%u", options.unit)
      .replace("%n", formattedNumber)
      .replace("%s", sign)
    ;

    return formattedNumber;
  };

  // Format currency with localization rules.
  // The options will be retrieved from the `number.currency.format` and
  // `number.format` scopes, in that order.
  //
  // Any missing option will be retrieved from the `I18n.toNumber` defaults and
  // the following options:
  //
  // - `unit`: `"$"`
  // - `precision`: `2`
  // - `format`: `"%u%n"`
  // - `delimiter`: `","`
  // - `separator`: `"."`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toCurrency = function(number, options) {
    var customLocale = (options || {}).locale;
    options = this.prepareOptions(
        options
      , this.lookup("number.currency.format", { locale: customLocale })
      , this.lookup("number.format", { locale: customLocale })
      , CURRENCY_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Localize several values.
  // You can provide the following scopes: `currency`, `number`, or `percentage`.
  // If you provide a scope that matches the `/^(date|time)/` regular expression
  // then the `value` will be converted by using the `I18n.toTime` function.
  //
  // It will default to the value's `toString` function.
  //
  I18n.localize = function(scope, value, options) {
    options || (options = {});

    switch (scope) {
      case "currency":
        return this.toCurrency(value);
      case "number":
        scope = this.lookup("number.format");
        return this.toNumber(value, scope);
      case "percentage":
        return this.toPercentage(value);
      default:
        var localizedValue;

        if (scope.match(/^(date|time)/)) {
          localizedValue = this.toTime(scope, value);
        } else {
          localizedValue = value.toString();
        }

        return this.interpolate(localizedValue, options);
    }
  };


  // Parse a given `date` string into a JavaScript Date object.
  // This function is time zone aware.
  //
  // The following string formats are recognized:
  //
  //    yyyy-mm-dd
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ssZ
  //    yyyy-mm-dd[ T]hh:mm::ss+0000
  //    yyyy-mm-dd[ T]hh:mm::ss+00:00
  //    yyyy-mm-dd[ T]hh:mm::ss.123Z
  //
  I18n.parseDate = function(date) {
    var matches, convertedDate, fraction;
    // we have a date, so just return it.
    if (typeof(date) == "object") {
      return date;
    };

    matches = date.toString().match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/);

    if (matches) {
      for (var i = 1; i <= 6; i++) {
        matches[i] = parseInt(matches[i], 10) || 0;
      }

      // month starts on 0
      matches[2] -= 1;

      fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;

      if (matches[8]) {
        convertedDate = new Date(Date.UTC(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction));
      } else {
        convertedDate = new Date(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction);
      }
    } else if (typeof(date) == "number") {
      // UNIX timestamp
      convertedDate = new Date();
      convertedDate.setTime(date);
    } else if (date.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
      // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
      // webkit/firefox, but not by IE, so we must parse it manually.
      convertedDate = new Date();
      convertedDate.setTime(Date.parse([
        RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5
      ].join(" ")));
    } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
      // a valid javascript format with timezone info
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    } else {
      // an arbitrary javascript string
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    }

    return convertedDate;
  };


  // Formats time according to the directives in the given format string.
  // The directives begins with a percent (%) character. Any text not listed as a
  // directive will be passed through to the output string.
  //
  // The accepted formats are:
  //
  //     %a  - The abbreviated weekday name (Sun)
  //     %A  - The full weekday name (Sunday)
  //     %b  - The abbreviated month name (Jan)
  //     %B  - The full month name (January)
  //     %c  - The preferred local date and time representation
  //     %d  - Day of the month (01..31)
  //     %-d - Day of the month (1..31)
  //     %H  - Hour of the day, 24-hour clock (00..23)
  //     %-H - Hour of the day, 24-hour clock (0..23)
  //     %I  - Hour of the day, 12-hour clock (01..12)
  //     %-I - Hour of the day, 12-hour clock (1..12)
  //     %m  - Month of the year (01..12)
  //     %-m - Month of the year (1..12)
  //     %M  - Minute of the hour (00..59)
  //     %-M - Minute of the hour (0..59)
  //     %p  - Meridian indicator (AM  or  PM)
  //     %S  - Second of the minute (00..60)
  //     %-S - Second of the minute (0..60)
  //     %w  - Day of the week (Sunday is 0, 0..6)
  //     %y  - Year without a century (00..99)
  //     %-y - Year without a century (0..99)
  //     %Y  - Year with century
  //     %z  - Timezone offset (+0545)
  //
  I18n.strftime = function(date, format) {
    var options = this.lookup("date")
      , meridianOptions = I18n.meridian()
    ;

    if (!options) {
      options = {};
    }

    options = this.prepareOptions(options, DATE);

    var weekDay = date.getDay()
      , day = date.getDate()
      , year = date.getFullYear()
      , month = date.getMonth() + 1
      , hour = date.getHours()
      , hour12 = hour
      , meridian = hour > 11 ? 1 : 0
      , secs = date.getSeconds()
      , mins = date.getMinutes()
      , offset = date.getTimezoneOffset()
      , absOffsetHours = Math.floor(Math.abs(offset / 60))
      , absOffsetMinutes = Math.abs(offset) - (absOffsetHours * 60)
      , timezoneoffset = (offset > 0 ? "-" : "+") +
          (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) +
          (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes)
    ;

    if (hour12 > 12) {
      hour12 = hour12 - 12;
    } else if (hour12 === 0) {
      hour12 = 12;
    }

    format = format.replace("%a", options.abbr_day_names[weekDay]);
    format = format.replace("%A", options.day_names[weekDay]);
    format = format.replace("%b", options.abbr_month_names[month]);
    format = format.replace("%B", options.month_names[month]);
    format = format.replace("%d", padding(day));
    format = format.replace("%e", day);
    format = format.replace("%-d", day);
    format = format.replace("%H", padding(hour));
    format = format.replace("%-H", hour);
    format = format.replace("%I", padding(hour12));
    format = format.replace("%-I", hour12);
    format = format.replace("%m", padding(month));
    format = format.replace("%-m", month);
    format = format.replace("%M", padding(mins));
    format = format.replace("%-M", mins);
    format = format.replace("%p", meridianOptions[meridian]);
    format = format.replace("%S", padding(secs));
    format = format.replace("%-S", secs);
    format = format.replace("%w", weekDay);
    format = format.replace("%y", padding(year));
    format = format.replace("%-y", padding(year).replace(/^0+/, ""));
    format = format.replace("%Y", year);
    format = format.replace("%z", timezoneoffset);

    return format;
  };

  // Convert the given dateString into a formatted date.
  I18n.toTime = function(scope, dateString) {
    var date = this.parseDate(dateString)
      , format = this.lookup(scope)
    ;

    if (date.toString().match(/invalid/i)) {
      return date.toString();
    }

    if (!format) {
      return date.toString();
    }

    return this.strftime(date, format);
  };

  // Convert a number into a formatted percentage value.
  I18n.toPercentage = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.percentage.format")
      , this.lookup("number.format")
      , PERCENTAGE_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Convert a number into a readable size representation.
  I18n.toHumanSize = function(number, options) {
    var kb = 1024
      , size = number
      , iterations = 0
      , unit
      , precision
    ;

    while (size >= kb && iterations < 4) {
      size = size / kb;
      iterations += 1;
    }

    if (iterations === 0) {
      unit = this.t("number.human.storage_units.units.byte", {count: size});
      precision = 0;
    } else {
      unit = this.t("number.human.storage_units.units." + SIZE_UNITS[iterations]);
      precision = (size - Math.floor(size) === 0) ? 0 : 1;
    }

    options = this.prepareOptions(
        options
      , {unit: unit, precision: precision, format: "%n%u", delimiter: ""}
    );

    return this.toNumber(size, options);
  };

  I18n.getFullScope = function(scope, options) {
    options = this.prepareOptions(options);

    // Deal with the scope as an array.
    if (scope.constructor === Array) {
      scope = scope.join(this.defaultSeparator);
    }

    // Deal with the scope option provided through the second argument.
    //
    //    I18n.t('hello', {scope: 'greetings'});
    //
    if (options.scope) {
      scope = [options.scope, scope].join(this.defaultSeparator);
    }

    return scope;
  }

  // Set aliases, so we can save some typing.
  I18n.t = I18n.translate;
  I18n.l = I18n.localize;
  I18n.p = I18n.pluralize;

  // HACK, export default formats for use in our methods
  I18n.NUMBER_FORMAT = NUMBER_FORMAT;
  I18n.CURRENCY_FORMAT = CURRENCY_FORMAT;
  I18n.PERCENTAGE_FORMAT = PERCENTAGE_FORMAT;

// HACK, HubSpot customization so that the config can be set before the library is loaded.
// (more info at https://git.hubteam.com/HubSpot/I18n/commit/4187783fba78f9249817e16487bc0c28fa3f0557)
// })(typeof(exports) === "undefined" ? (this.I18n = {}) : exports);
})(typeof(exports) === "undefined" ? (this.I18n = this.I18n || {}) : exports);
// END HACK


(function () {
var slice = [].slice;

I18n.debugLog = function() {
  var args, enabled;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (typeof document === "undefined" || document === null) {
    return;
  }
  enabled = this.I18N_DEBUG_LOG || window.I18N_DEBUG;
  try {
    enabled || (enabled = localStorage.I18N_DEBUG_LOG === "true" || localStorage.I18N_DEBUG === "true");
  } catch (undefined) {}
  if (enabled !== true) {
    return;
  }
  args.unshift('I18n:');
  if (window.parent !== window) {
    args.unshift('(IFRAME)');
  }
  return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log.apply(console, args) : void 0 : void 0;
};

I18n.onAnyTrigger = function() {
  var args, eventName;
  eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  return I18n.debugLog.apply(I18n, ["triggered " + eventName].concat(slice.call(args)));
};
}());

(function(I18n) {
  // SafeString type to be used to mark I18n params as _not_ needing escaping.
  // (concept borrowed from http://handlebarsjs.com/#html-escaping)
  function SafeString(string) {
    // Work even if called without `new`
    if (!(this instanceof SafeString)) {
      return new SafeString(string);
    } else {
      this.string = string;
    }
  }

  SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
    return '' + this.string;
  };

  I18n.SafeString = SafeString;
})(I18n);


(function () {
I18n.whenDOMContentLoaded = function(callback) {
  var ref;
  if ((ref = document.readyState) === 'interactive' || ref === 'complete') {
    setTimeout(callback, 1);
  } else {
    document.addEventListener('DOMContentLoaded', callback, false);
  }
};
}());

// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawFixed
(function(I18n) {
  var arrJoin = Array.prototype.join;

  function toRawFixed(
    x,
    minIntegerDigits,
    minFractionDigits,
    maxFractionDigits
  ) {
    var idx,
      result = Number.prototype.toFixed.call(x, maxFractionDigits),
      intDigits = result.split('.')[0].length,
      cut = maxFractionDigits - minFractionDigits,
      exp = (idx = result.indexOf('e')) > -1 ? result.slice(idx + 1) : 0;

    if (exp) {
      result = result.slice(0, idx).replace('.', '');
      result +=
        arrJoin.call(Array(exp - (result.length - 1) + 1), '0') +
        '.' +
        arrJoin.call(Array(maxFractionDigits + 1), '0');

      intDigits = result.length;
    }

    // Repeat while cut > 0 and the last character of result is "0":
    while (cut > 0 && result.slice(-1) === '0') {
      result = result.slice(0, -1);
      cut--;
    }

    // If the last character of result is ".", then remove it
    if (result.slice(-1) === '.') result = result.slice(0, -1);

    // If int < minIntegerDigits, then pad front with zeros
    if (intDigits < minIntegerDigits)
      var padding = arrJoin.call(Array(minIntegerDigits - intDigits + 1), '0');

    return (padding ? padding : '') + result;
  }

  I18n.util = I18n.util || {};
  I18n.util.toRawFixed = toRawFixed;
})(I18n);


// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawPrecision
(function(I18n) {
  var arrJoin = Array.prototype.join;

  // A function to deal with the inaccuracy of calculating log10 in pre-ES6
  // JavaScript environments. Math.log(num) / Math.LN10 was responsible for
  // causing issue #62.
  function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') {
      return Math.floor(Math.log10(n));
    }

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
  }

  function toRawPrecision(x, minPrecision, maxPrecision) {
    var result,
      numDigits,
      isNegative = x < 0;

    // Deal with negative values later
    x = Math.abs(x);

    // If 0, pad out to maxPrecision 0 characters
    if (x === 0) {
      result = arrJoin.call(Array(maxPrecision + 1), '0');
      numDigits = 1;
    } else {
      // Positive values mean # of int digits and negative values mean # of fractional digits
      numDigits = log10Floor(Math.abs(x)) + 1;

      // Easier to get to result from here
      var factor = Math.round(
        Math.exp(Math.abs(numDigits - maxPrecision) * Math.LN10)
      );

      // b. Let result be the String consisting of the digits of the decimal
      //  representation of n (in order, with no leading zeroes)
      result = String(
        Math.round(numDigits - maxPrecision < 0 ? x * factor : x / factor)
      );
    }

    // If numDigits ≥ maxPrecision, then pad the end of the number with zeros
    if (numDigits > maxPrecision) {
      result = result + arrJoin.call(Array(numDigits - maxPrecision + 1), '0');
      return isNegative ? '-' + result : result;

      // If numDigits = maxPrecision, then don't need to do anything
    } else if (numDigits === maxPrecision) {
      return isNegative ? '-' + result : result;

      // If numDigits > 0, then format as a decimal number with maxPrecision total digits
    } else if (numDigits > 0) {
      //var cutPoint = isNegative ? numDigits : numDigits + 1;
      result = result.slice(0, numDigits) + '.' + result.slice(numDigits);

      // If numDigits <= 0, then pad 0 zeros in front of decimal as needed
    } else if (numDigits <= 0) {
      result = '0.' + arrJoin.call(Array(-numDigits + 1), '0') + result;
    }

    // If result contains the character ".", and maxPrecision > minPrecision, then
    if (result.indexOf('.') >= 0 && maxPrecision > minPrecision) {
      var cut = maxPrecision - minPrecision;

      // Repeat while cut > 0 and the last character of result is "0":
      while (cut > 0 && result.charAt(result.length - 1) === '0') {
        result = result.slice(0, -1);
        cut--;
      }

      // If the last character of result is ".", then remove it
      if (result.charAt(result.length - 1) === '.')
        result = result.slice(0, -1);
    }

    return isNegative ? '-' + result : result;
  }

  I18n.util = I18n.util || {};
  I18n.util.log10Floor = log10Floor;
  I18n.util.toRawPrecision = toRawPrecision;
})(I18n);


//! moment.js

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));



;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


(function () {
if (typeof document !== "undefined" && document !== null) {
  hubspot.define('hubspot.carmen.client', ['hubspot.PortalIdParser', 'enviro'], function(PortalIdParser, Env) {
    var handleResponse, loadFromEarlyRequesterOrCarmen, makeRequestViaCarmenService, pendingCBs, portalId, setPortalIdIfNotAvailable, tags, triggerCallbacks;
    portalId = PortalIdParser.get({
      preserveGlobalId: true
    });
    tags = [];
    pendingCBs = [];
    makeRequestViaCarmenService = function(cb) {
      var callback, suffix, tag, url;
      if (cb != null) {
        pendingCBs.push(cb);
      }
      suffix = '';
      if (Env.getShort('carmen.api') === 'qa') {
        suffix = 'qa';
      }
      callback = 'hubspot.carmen.client.handleResponse';
      url = "https://app.hubspot" + suffix + ".com/carmen/locale.js?portalId=" + portalId + "&callback=" + callback;
      tag = document.createElement('script');
      tag.src = url;
      tags.push(tag);
      return document.querySelector('head').appendChild(tag);
    };
    triggerCallbacks = function(data) {
      var cb, i, len;
      for (i = 0, len = pendingCBs.length; i < len; i++) {
        cb = pendingCBs[i];
        cb(data);
      }
      return pendingCBs = [];
    };
    handleResponse = function(data) {
      var i, len, tag;
      for (i = 0, len = tags.length; i < len; i++) {
        tag = tags[i];
        tag.parentNode.removeChild(tag);
      }
      tags = [];
      return triggerCallbacks(data);
    };
    loadFromEarlyRequesterOrCarmen = function(cb, onError, loadLocaleFallback) {
      var earlyAuthRequest, ref;
      if (cb != null) {
        pendingCBs.push(cb);
      }
      earlyAuthRequest = (ref = window.quickFetch) != null ? ref.getRequestStateByName('api-verify') : void 0;
      if (earlyAuthRequest != null) {
        earlyAuthRequest.whenFinished((function(_this) {
          return function(apiVerifyData) {
            var langEnabled, locale, ref1, ref2, ref3, ref4, timezone;
            timezone = apiVerifyData != null ? (ref1 = apiVerifyData.portal) != null ? (ref2 = ref1.timezone) != null ? ref2.id : void 0 : void 0 : void 0;
            locale = apiVerifyData != null ? (ref3 = apiVerifyData.user) != null ? ref3.locale : void 0 : void 0;
            langEnabled = apiVerifyData != null ? (ref4 = apiVerifyData.user) != null ? ref4.lang_enabled : void 0 : void 0;
            if ((timezone != null) && (locale != null)) {
              return triggerCallbacks({
                timezone: timezone,
                locale: locale,
                langEnabled: langEnabled
              });
            } else {
              return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
            }
          };
        })(this));
        return earlyAuthRequest.onError((function(_this) {
          return function(xhr, statusCode, error) {
            return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
          };
        })(this));
      } else {
        return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
      }
    };
    setPortalIdIfNotAvailable = function(pid) {
      if (!portalId) {
        return portalId = pid;
      }
    };
    return {
      load: loadFromEarlyRequesterOrCarmen,
      handleResponse: handleResponse,
      setPortalIdIfNotAvailable: setPortalIdIfNotAvailable
    };
  });
}
}());

(function () {
var Evented, k, ref, v,
  slice = [].slice;

Evented = (function() {
  function Evented() {}

  Evented.prototype.on = function(event, handler, ctx, once) {
    var base, e, j, len, ref, results;
    if (once == null) {
      once = false;
    }
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        results.push(this.on(e, handler, ctx, once));
      }
      return results;
    } else {
      if (this.bindings == null) {
        this.bindings = {};
      }
      if ((base = this.bindings)[event] == null) {
        base[event] = [];
      }
      return this.bindings[event].push({
        handler: handler,
        ctx: ctx,
        once: once
      });
    }
  };

  Evented.prototype.once = function(event, handler, ctx) {
    return this.on(event, handler, ctx, true);
  };

  Evented.prototype.off = function(event, handler) {
    var i, ref, results;
    if (((ref = this.bindings) != null ? ref[event] : void 0) == null) {
      return;
    }
    if (handler == null) {
      return delete this.bindings[event];
    } else {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        if (this.bindings[event][i].handler === handler) {
          results.push(this.bindings[event].splice(i, 1));
        } else {
          results.push(i++);
        }
      }
      return results;
    }
  };

  Evented.prototype.when = function(event, handler, ctx) {
    var e, j, len, ref, ref1;
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        this.when(e, handler, ctx);
      }
      return;
    }
    if ((ref1 = this.fired) != null ? ref1[event] : void 0) {
      return handler.call(ctx != null ? ctx : this);
    } else {
      return this.once(event, handler, ctx);
    }
  };

  Evented.prototype.trigger = function() {
    var args, ctx, event, handler, i, once, ref, ref1, results;
    event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (this.fired == null) {
      this.fired = {};
    }
    this.fired[event] = true;
    if (typeof this.onAnyTrigger === "function") {
      this.onAnyTrigger.apply(this, [event].concat(slice.call(args)));
    }
    if ((ref = this.bindings) != null ? ref[event] : void 0) {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        ref1 = this.bindings[event][i], handler = ref1.handler, ctx = ref1.ctx, once = ref1.once;
        if (once) {
          this.bindings[event].splice(i, 1);
        } else {
          i++;
        }
        results.push(handler.apply(ctx != null ? ctx : this, args));
      }
      return results;
    }
  };

  return Evented;

})();

if ((typeof window !== "undefined" && window !== null) && !window.isServer) {
  ref = Evented.prototype;
  for (k in ref) {
    v = ref[k];
    window.I18n[k] = v;
  }
}
}());

(function () {
var init, ref;

init = function(moment) {
  I18n.moment = moment;
  if (typeof I18n.trigger === "function") {
    I18n.trigger('moment:init');
  }
  I18n.fallbacks = true;
  if (I18n.translationsLoaded == null) {
    I18n.translationsLoaded = {};
  }
  if (I18n.moment.locale != null) {
    return I18n.moment.locale(I18n.locale);
  } else {
    return I18n.moment.lang(I18n.locale);
  }
};

if (typeof define !== "undefined" && define !== null ? define.amd : void 0) {
  define(['moment'], init);
} else if (typeof window !== "undefined" && window !== null) {
  init(window.moment);
} else if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  init(require('moment'));
}

if (I18n.translations == null) {
  I18n.translations = {};
}

if (typeof window !== "undefined" && window !== null ? (ref = window.I18n) != null ? ref.loaded : void 0 : void 0) {
  console.error("I18n/init.js brought in more than once");
}

I18n.loaded = true;
}());

(function () {
hubspot.defineEager('hubspot.i18n.pre', [], I18n);

I18n.when('timezone:ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.timezone : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.timezone', [], I18n);
  }
});

I18n.when('locale:ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.locale : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.locale', [], I18n);
  }
});

I18n.when('ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.info : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.info', [], I18n);
  }
});

I18n.when('timeout', function() {
  var ref, ref1;
  if (((ref = hubspot.i18n) != null ? ref.locale : void 0) == null) {
    hubspot.defineEager('hubspot.i18n.locale', [], I18n);
  }
  if (((ref1 = hubspot.i18n) != null ? ref1.timezone : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.timezone', [], I18n);
  }
});
}());

(function () {
var Promise;

Promise = (function() {
  function Promise() {
    this.cbs = [];
  }

  Promise.prototype.then = function(yep, nope) {
    switch (this.state) {
      case 'resolved':
        return typeof yep === "function" ? yep(this.value) : void 0;
      case 'rejected':
        return typeof nope === "function" ? nope(this.value) : void 0;
      default:
        return this.cbs.push([yep, nope]);
    }
  };

  Promise.prototype.resolve = function(value) {
    this.value = value;
    this.state = 'resolved';
    return this._run();
  };

  Promise.prototype.reject = function(value) {
    this.value = value;
    this.state = 'rejected';
    return this._run();
  };

  Promise.prototype._run = function() {
    var cbs, i, len, ref;
    if (this.cbs == null) {
      return;
    }
    ref = this.cbs;
    for (i = 0, len = ref.length; i < len; i++) {
      cbs = ref[i];
      this.then.apply(this, cbs);
    }
    return this.cbs = null;
  };

  Promise.prototype.done = Promise.prototype.then;

  return Promise;

})();

I18n.Locale = new Promise;

I18n.when('locale:ready', function() {
  return I18n.Locale.resolve(I18n);
});

I18n.Timezone = new Promise;

I18n.when('timezone:ready', function() {
  return I18n.Timezone.resolve(I18n);
});

I18n.Info = new Promise;

I18n.when('ready', function() {
  var i18nDuration, i18nLangLocale, ref, ref1;
  I18n.Info.resolve(I18n);
  try {
    window.performance.mark('mark_i18n_load_successful');
    window.performance.measure('measure_i18n_load_time', 'mark_i18n_load_start', 'mark_i18n_load_successful');
    if (i18nDuration = window.performance.getEntriesByName('measure_i18n_load_time')[0].duration) {
      if ((ref = window.newrelic) != null) {
        ref.setCustomAttribute('i18nTime', i18nDuration);
      }
    }
    i18nLangLocale = I18n.locale !== 'en-us' && !I18n.langEnabled && !I18n.publicPage ? 'en-us' : I18n.locale;
    return (ref1 = window.newrelic) != null ? ref1.setCustomAttribute('i18nLangLocale', i18nLangLocale) : void 0;
  } catch (undefined) {}
});

I18n.Promise = Promise;
}());

hns('I18n.countries', {});

hns('I18n.translations.bn', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 2,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.cs', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "B",
            "few": "B",
            "other": "B"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.da', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.de', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "€",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " und ",
          "lastWordConnector": " und "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " oder ",
          "lastWordConnector": " oder "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 Tausend",
            "other": "0 Tausend"
          },
          "10000": {
            "one": "00 Tausend",
            "other": "00 Tausend"
          },
          "100000": {
            "one": "000 Tausend",
            "other": "000 Tausend"
          },
          "1000000": {
            "one": "0 Million",
            "other": "0 Millionen"
          },
          "10000000": {
            "one": "00 Millionen",
            "other": "00 Millionen"
          },
          "100000000": {
            "one": "000 Millionen",
            "other": "000 Millionen"
          },
          "1000000000": {
            "one": "0 Milliarde",
            "other": "0 Milliarden"
          },
          "10000000000": {
            "one": "00 Milliarden",
            "other": "00 Milliarden"
          },
          "100000000000": {
            "one": "000 Milliarden",
            "other": "000 Milliarden"
          },
          "1000000000000": {
            "one": "0 Billion",
            "other": "0 Billionen"
          },
          "10000000000000": {
            "one": "00 Billionen",
            "other": "00 Billionen"
          },
          "100000000000000": {
            "one": "000 Billionen",
            "other": "000 Billionen"
          }
        },
        "short": {
          "1000": {
            "one": "0 Tsd.",
            "other": "0 Tsd."
          },
          "10000": {
            "one": "00 Tsd.",
            "other": "00 Tsd."
          },
          "100000": {
            "one": "000 Tsd.",
            "other": "000 Tsd."
          },
          "1000000": {
            "one": "0 Mio",
            "other": "0 Mio"
          },
          "10000000": {
            "one": "00 Mio",
            "other": "00 Mio"
          },
          "100000000": {
            "one": "000 Mio",
            "other": "000 Mio"
          },
          "1000000000": {
            "one": "0 Mrd",
            "other": "0 Mrd"
          },
          "10000000000": {
            "one": "00 Mrd",
            "other": "00 Mrd"
          },
          "100000000000": {
            "one": "000 Mrd",
            "other": "000 Mrd"
          },
          "1000000000000": {
            "one": "0 Bio.",
            "other": "0 Bio."
          },
          "10000000000000": {
            "one": "00 Bio.",
            "other": "00 Bio."
          },
          "100000000000000": {
            "one": "000 Bio.",
            "other": "000 Bio."
          }
        }
      }
    }
  }
});

hns('I18n.translations.el', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.en-au', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ca', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-gb', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "£"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ie', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-in', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "₹"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-nz', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-us', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en', {
  "number": {
    "format": {
      "precision": 3,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": false
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": {
            "one": " byte",
            "other": " bytes"
          },
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 thousand",
            "other": "0 thousand"
          },
          "10000": {
            "one": "00 thousand",
            "other": "00 thousand"
          },
          "100000": {
            "one": "000 thousand",
            "other": "000 thousand"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 million"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 million"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 million"
          },
          "1000000000": {
            "one": "0 billion",
            "other": "0 billion"
          },
          "10000000000": {
            "one": "00 billion",
            "other": "00 billion"
          },
          "100000000000": {
            "one": "000 billion",
            "other": "000 billion"
          },
          "1000000000000": {
            "one": "0 trillion",
            "other": "0 trillion"
          },
          "10000000000000": {
            "one": "00 trillion",
            "other": "00 trillion"
          },
          "100000000000000": {
            "one": "000 trillion",
            "other": "000 trillion"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000": {
            "one": "000B",
            "other": "000B"
          },
          "1000000000000": {
            "one": "0T",
            "other": "0T"
          },
          "10000000000000": {
            "one": "00T",
            "other": "00T"
          },
          "100000000000000": {
            "one": "000T",
            "other": "000T"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-ar', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0MM",
            "other": "0MM"
          },
          "10000000": {
            "one": "00MM",
            "other": "00MM"
          },
          "100000000": {
            "one": "000MM",
            "other": "000MM"
          },
          "1000000000": {
            "one": "0000MM",
            "other": "0000MM"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-mx', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "$",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": ", y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.fi', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "tavu",
            "other": "tavua"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ja ",
          "lastWordConnector": " ja "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " tai ",
          "lastWordConnector": " tai "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tuhat",
            "other": "0 tuhatta"
          },
          "10000": {
            "one": "00 tuhatta",
            "other": "00 tuhatta"
          },
          "100000": {
            "one": "000 tuhatta",
            "other": "000 tuhatta"
          },
          "1000000": {
            "one": "0 miljoona",
            "other": "0 miljoonaa"
          },
          "10000000": {
            "one": "00 miljoonaa",
            "other": "00 miljoonaa"
          },
          "100000000": {
            "one": "000 miljoonaa",
            "other": "000 miljoonaa"
          },
          "1000000000": {
            "one": "0 miljardi",
            "other": "0 miljardia"
          },
          "10000000000": {
            "one": "00 miljardia",
            "other": "00 miljardia"
          },
          "100000000000": {
            "one": "000 miljardia",
            "other": "000 miljardia"
          },
          "1000000000000": {
            "one": "0 biljoona",
            "other": "0 biljoonaa"
          },
          "10000000000000": {
            "one": "00 biljoonaa",
            "other": "00 biljoonaa"
          },
          "100000000000000": {
            "one": "000 biljoonaa",
            "other": "000 biljoonaa"
          }
        },
        "short": {
          "1000": {
            "one": "0 t.",
            "other": "0 t."
          },
          "10000": {
            "one": "00 t.",
            "other": "00 t."
          },
          "100000": {
            "one": "000 t.",
            "other": "000 t."
          },
          "1000000": {
            "one": "0 milj.",
            "other": "0 milj."
          },
          "10000000": {
            "one": "00 milj.",
            "other": "00 milj."
          },
          "100000000": {
            "one": "000 milj.",
            "other": "000 milj."
          },
          "1000000000": {
            "one": "0 mrd.",
            "other": "0 mrd."
          },
          "10000000000": {
            "one": "00 mrd.",
            "other": "00 mrd."
          },
          "100000000000": {
            "one": "000 mrd.",
            "other": "000 mrd."
          },
          "1000000000000": {
            "one": "0 bilj.",
            "other": "0 bilj."
          },
          "10000000000000": {
            "one": "00 bilj.",
            "other": "00 bilj."
          },
          "100000000000000": {
            "one": "000 bilj.",
            "other": "000 bilj."
          }
        }
      }
    }
  }
});

hns('I18n.translations.fr', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "tb": "To"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " et ",
          "lastWordConnector": " et "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": " ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 millier",
            "other": "0 mille"
          },
          "10000": {
            "one": "00 millier",
            "other": "00 mille"
          },
          "100000": {
            "one": "000 millier",
            "other": "000 mille"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 millions"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 millions"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 millions"
          },
          "1000000000": {
            "one": "0 milliard",
            "other": "0 milliards"
          },
          "10000000000": {
            "one": "00 milliard",
            "other": "00 milliards"
          },
          "100000000000": {
            "one": "000 milliards",
            "other": "000 milliards"
          },
          "1000000000000": {
            "one": "0 billion",
            "other": "0 billions"
          },
          "10000000000000": {
            "one": "00 billions",
            "other": "00 billions"
          },
          "100000000000000": {
            "one": "000 billions",
            "other": "000 billions"
          }
        },
        "short": {
          "1000": {
            "one": "0 k",
            "other": "0 k"
          },
          "10000": {
            "one": "00 k",
            "other": "00 k"
          },
          "100000": {
            "one": "000 k",
            "other": "000 k"
          },
          "1000000": {
            "one": "0 M",
            "other": "0 M"
          },
          "10000000": {
            "one": "00 M",
            "other": "00 M"
          },
          "100000000": {
            "one": "000 M",
            "other": "000 M"
          },
          "1000000000": {
            "one": "0 Md",
            "other": "0 Md"
          },
          "10000000000": {
            "one": "00 Md",
            "other": "00 Md"
          },
          "100000000000": {
            "one": "000 Md",
            "other": "000 Md"
          },
          "1000000000000": {
            "one": "0 Bn",
            "other": "0 Bn"
          },
          "10000000000000": {
            "one": "00 Bn",
            "other": "00 Bn"
          },
          "100000000000000": {
            "one": "000 Bn",
            "other": "000 Bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.hr', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "bajt",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.hu', {
  "number": {
    "currency": {
      "format": {
        "delimiter": "",
        "format": "%n %u",
        "precision": 0,
        "separator": ",",
        "significant": true,
        "strip_insignificant_zeros": true
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 2,
      "separator": ",",
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.id', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.it', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": " o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 migliaio",
            "other": "0 migliaia"
          },
          "10000": {
            "one": "00 migliaia",
            "other": "00 migliaia"
          },
          "100000": {
            "one": "000 migliaia",
            "other": "000 migliaia"
          },
          "1000000": {
            "one": "0 milione",
            "other": "0 milioni"
          },
          "10000000": {
            "one": "00 milioni",
            "other": "00 milioni"
          },
          "100000000": {
            "one": "000 milioni",
            "other": "000 milioni"
          },
          "1000000000": {
            "one": "0 miliardo",
            "other": "0 miliardi"
          },
          "10000000000": {
            "one": "00 miliardi",
            "other": "00 miliardi"
          },
          "100000000000": {
            "one": "000 miliardi",
            "other": "000 miliardi"
          },
          "1000000000000": {
            "one": "0 migliaio di miliardi",
            "other": "0 migliaia di miliardi"
          },
          "10000000000000": {
            "one": "00 migliaia di miliardi",
            "other": "00 migliaia di miliardi"
          },
          "100000000000000": {
            "one": "000 migliaia di miliardi",
            "other": "000 migliaia di miliardi"
          }
        },
        "short": {
          "1000": {
            "one": "0",
            "other": "0"
          },
          "10000": {
            "one": "0",
            "other": "0"
          },
          "100000": {
            "one": "0",
            "other": "0"
          },
          "1000000": {
            "one": "0 Mln",
            "other": "0 Mln"
          },
          "10000000": {
            "one": "00 Mln",
            "other": "00 Mln"
          },
          "100000000": {
            "one": "000 Mln",
            "other": "000 Mln"
          },
          "1000000000": {
            "one": "0 Mld",
            "other": "0 Mld"
          },
          "10000000000": {
            "one": "00 Mld",
            "other": "00 Mld"
          },
          "100000000000": {
            "one": "000 Mld",
            "other": "000 Mld"
          },
          "1000000000000": {
            "one": "0 Bln",
            "other": "0 Bln"
          },
          "10000000000000": {
            "one": "00 Bln",
            "other": "00 Bln"
          },
          "100000000000000": {
            "one": "000 Bln",
            "other": "000 Bln"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ja', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "バイト",
          "gb": "ギガバイト",
          "kb": "キロバイト",
          "mb": "メガバイト",
          "tb": "テラバイト"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "と",
          "twoWordsConnector": "と",
          "lastWordConnector": "と"
        },
        "exclusive": {
          "wordsConnector": "または",
          "twoWordsConnector": "または",
          "lastWordConnector": "または"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ko', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "바이트",
          "gb": "기가바이트",
          "kb": "킬로바이트",
          "mb": "메가바이트",
          "tb": "테라바이트"
        }
      }
    }
  }
});

hns('I18n.translations.nl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " en ",
          "lastWordConnector": " en "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " of ",
          "lastWordConnector": ", of "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 duizend",
            "other": "0 duizend"
          },
          "10000": {
            "one": "00 duizend",
            "other": "00 duizend"
          },
          "100000": {
            "one": "000 duizend",
            "other": "000 duizend"
          },
          "1000000": {
            "one": "0 miljoen",
            "other": "0 miljoen"
          },
          "10000000": {
            "one": "00 miljoen",
            "other": "00 miljoen"
          },
          "100000000": {
            "one": "000 miljoen",
            "other": "000 miljoen"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljard"
          },
          "10000000000": {
            "one": "00 miljard",
            "other": "00 miljard"
          },
          "100000000000": {
            "one": "000 miljard",
            "other": "000 miljard"
          },
          "1000000000000": {
            "one": "0 biljoen",
            "other": "0 biljoen"
          },
          "10000000000000": {
            "one": "00 biljoen",
            "other": "00 biljoen"
          },
          "100000000000000": {
            "one": "000 biljoen",
            "other": "000 biljoen"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0 mln.",
            "other": "0 mln."
          },
          "10000000": {
            "one": "00 mln.",
            "other": "00 mln."
          },
          "100000000": {
            "one": "000 mln.",
            "other": "000 mln."
          },
          "1000000000": {
            "one": "0 mld.",
            "other": "0 mld."
          },
          "10000000000": {
            "one": "00 mld.",
            "other": "00 mld."
          },
          "100000000000": {
            "one": "000 mld.",
            "other": "000 mld."
          },
          "1000000000000": {
            "one": "0 bln.",
            "other": "0 bln."
          },
          "10000000000000": {
            "one": "00 bln.",
            "other": "00 bln."
          },
          "100000000000000": {
            "one": "000 bln.",
            "other": "000 bln."
          }
        }
      }
    }
  }
});

hns('I18n.translations.no-no', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "bajt",
            "few": "bajty",
            "many": "bajtów",
            "other": "bajty"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pt-br', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "R$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": ", ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 milhão",
            "other": "0 milhões"
          },
          "10000000": {
            "one": "00 milhão",
            "other": "00 milhões"
          },
          "100000000": {
            "one": "000 milhão",
            "other": "000 milhões"
          },
          "1000000000": {
            "one": "0 bilhão",
            "other": "0 bilhões"
          },
          "10000000000": {
            "one": "00 bilhão",
            "other": "00 bilhões"
          },
          "100000000000": {
            "one": "000 bilhão",
            "other": "000 bilhões"
          },
          "1000000000000": {
            "one": "0 trilhão",
            "other": "0 trilhões"
          },
          "10000000000000": {
            "one": "00 trilhão",
            "other": "00 trilhões"
          },
          "100000000000000": {
            "one": "000 trilhão",
            "other": "000 trilhões"
          }
        },
        "short": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 mi",
            "other": "0 mi"
          },
          "10000000": {
            "one": "00 mi",
            "other": "00 mi"
          },
          "100000000": {
            "one": "000 mi",
            "other": "000 mi"
          },
          "1000000000": {
            "one": "0 bi",
            "other": "0 bi"
          },
          "10000000000": {
            "one": "00 bi",
            "other": "00 bi"
          },
          "100000000000": {
            "one": "000 bi",
            "other": "000 bi"
          },
          "1000000000000": {
            "one": "0 tri",
            "other": "0 tri"
          },
          "10000000000000": {
            "one": "00 tri",
            "other": "00 tri"
          },
          "100000000000000": {
            "one": "000 tri",
            "other": "000 tri"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ro', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.ru', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "байт",
          "gb": "ГБ",
          "kb": "КБ",
          "mb": "МБ",
          "tb": "ТБ"
        }
      }
    }
  }
});

hns('I18n.translations.sv', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "kr"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " och ",
          "lastWordConnector": " och "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " eller ",
          "lastWordConnector": ", eller "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tusen",
            "other": "0 tusen"
          },
          "10000": {
            "one": "00 tusen",
            "other": "00 tusen"
          },
          "100000": {
            "one": "000 tusen",
            "other": "000 tusen"
          },
          "1000000": {
            "one": "0 miljon",
            "other": "0 miljoner"
          },
          "10000000": {
            "one": "00 miljon",
            "other": "00 miljoner"
          },
          "100000000": {
            "one": "000 miljoner",
            "other": "000 miljoner"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljarder"
          },
          "10000000000": {
            "one": "00 miljarder",
            "other": "00 miljarder"
          },
          "100000000000": {
            "one": "000 miljarder",
            "other": "000 miljarder"
          },
          "1000000000000": {
            "one": "0 biljon",
            "other": "0 biljoner"
          },
          "10000000000000": {
            "one": "00 biljoner",
            "other": "00 biljoner"
          },
          "100000000000000": {
            "one": "000 biljoner",
            "other": "000 biljoner"
          }
        },
        "short": {
          "1000": {
            "one": "0 tn",
            "other": "0 tn"
          },
          "10000": {
            "one": "00 tn",
            "other": "00 tn"
          },
          "100000": {
            "one": "000 tn",
            "other": "000 tn"
          },
          "1000000": {
            "one": "0 mn",
            "other": "0 mn"
          },
          "10000000": {
            "one": "00 mn",
            "other": "00 mn"
          },
          "100000000": {
            "one": "000 mn",
            "other": "000 mn"
          },
          "1000000000": {
            "one": "0 md",
            "other": "0 md"
          },
          "10000000000": {
            "one": "00 md",
            "other": "00 md"
          },
          "100000000000": {
            "one": "000 md",
            "other": "000 md"
          },
          "1000000000000": {
            "one": "0 bn",
            "other": "0 bn"
          },
          "10000000000000": {
            "one": "00 bn",
            "other": "00 bn"
          },
          "100000000000000": {
            "one": "000 bn",
            "other": "000 bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.th', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%n %u",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "ไบต์",
          "gb": "จิกะไบต์",
          "kb": "กิโลไบต์",
          "mb": "เมกะไบต์",
          "tb": "เทระไบต์"
        }
      }
    }
  }
});

hns('I18n.translations.vi', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 0,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.zh-cn', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "CN¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.zh-hk', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "HK$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0 千"
          },
          "10000": {
            "other": "0萬"
          },
          "100000": {
            "other": "00萬"
          },
          "1000000": {
            "other": "000萬"
          },
          "10000000": {
            "other": "0000萬"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0K"
          },
          "10000": {
            "other": "00K"
          },
          "100000": {
            "other": "000K"
          },
          "1000000": {
            "other": "0M"
          },
          "10000000": {
            "other": "00M"
          },
          "100000000": {
            "other": "000M"
          },
          "1000000000": {
            "other": "0B"
          },
          "10000000000": {
            "other": "00B"
          },
          "100000000000": {
            "other": "000B"
          },
          "1000000000000": {
            "other": "0T"
          },
          "10000000000000": {
            "other": "00T"
          },
          "100000000000000": {
            "other": "000T"
          }
        }
      }
    }
  }
});




hns('I18n.baseLocales', {
  "en": {
    "language": "en",
    "beta": false,
    "defaultLocale": "en-us",
    "availableLocale": [
      "en-us",
      "en-ca",
      "en-gb",
      "en-ie",
      "en-au",
      "en-nz",
      "en-in",
      "es-ar",
      "es-mx",
      "es",
      "pt-br",
      "de",
      "fr",
      "it",
      "fi",
      "sv",
      "nl",
      "ja",
      "zh-cn",
      "zh-hk"
    ]
  },
  "es": {
    "language": "es",
    "beta": false,
    "defaultLocale": "es-ar",
    "availableLocale": [
      "es",
      "es-ar",
      "es-mx"
    ]
  },
  "de": {
    "language": "de",
    "beta": false,
    "defaultLocale": "de",
    "availableLocale": [
      "de"
    ]
  },
  "ja": {
    "language": "ja",
    "beta": false,
    "defaultLocale": "ja",
    "availableLocale": [
      "ja"
    ]
  },
  "fr": {
    "language": "fr",
    "beta": false,
    "defaultLocale": "fr",
    "availableLocale": [
      "fr"
    ]
  },
  "pt-br": {
    "language": "pt",
    "beta": false,
    "defaultLocale": "pt-br",
    "availableLocale": [
      "pt-br"
    ]
  },
  "nl": {
    "language": "nl",
    "beta": false,
    "defaultLocale": "nl",
    "availableLocale": [
      "nl"
    ]
  }
});

hns('I18n.publicLocales', {
  "af": {
    "language": "af",
    "beta": true,
    "defaultLocale": "af",
    "availableLocale": [
      "af"
    ]
  },
  "ar-eg": {
    "language": "ar-eg",
    "beta": true,
    "defaultLocale": "ar-eg",
    "availableLocale": [
      "ar-eg"
    ]
  },
  "bg": {
    "language": "bg",
    "beta": true,
    "defaultLocale": "bg",
    "availableLocale": [
      "bg"
    ]
  },
  "bn": {
    "language": "bn",
    "beta": true,
    "defaultLocale": "bn",
    "availableLocale": [
      "bn"
    ]
  },
  "ca-es": {
    "language": "ca-es",
    "beta": true,
    "defaultLocale": "ca-es",
    "availableLocale": [
      "ca-es"
    ]
  },
  "cs": {
    "language": "cs",
    "beta": true,
    "defaultLocale": "cs",
    "availableLocale": [
      "cs"
    ]
  },
  "da": {
    "language": "da",
    "beta": true,
    "defaultLocale": "da",
    "availableLocale": [
      "da"
    ]
  },
  "el": {
    "language": "el",
    "beta": true,
    "defaultLocale": "el",
    "availableLocale": [
      "el"
    ]
  },
  "es-mx": {
    "language": "es-mx",
    "beta": true,
    "defaultLocale": "es-mx",
    "availableLocale": [
      "es-mx"
    ]
  },
  "fi": {
    "language": "fi",
    "beta": true,
    "defaultLocale": "fi",
    "availableLocale": [
      "fi"
    ]
  },
  "hr": {
    "language": "hr",
    "beta": true,
    "defaultLocale": "hr",
    "availableLocale": [
      "hr"
    ]
  },
  "hu": {
    "language": "hu",
    "beta": true,
    "defaultLocale": "hu",
    "availableLocale": [
      "hu"
    ]
  },
  "id": {
    "language": "id",
    "beta": true,
    "defaultLocale": "id",
    "availableLocale": [
      "id"
    ]
  },
  "it": {
    "language": "it",
    "beta": true,
    "defaultLocale": "it",
    "availableLocale": [
      "it"
    ]
  },
  "ko": {
    "language": "ko",
    "beta": true,
    "defaultLocale": "ko",
    "availableLocale": [
      "ko"
    ]
  },
  "no-no": {
    "language": "no-no",
    "beta": true,
    "defaultLocale": "no-no",
    "availableLocale": [
      "no-no"
    ]
  },
  "pl": {
    "language": "pl",
    "beta": true,
    "defaultLocale": "pl",
    "availableLocale": [
      "pl"
    ]
  },
  "ro": {
    "language": "ro",
    "beta": true,
    "defaultLocale": "ro",
    "availableLocale": [
      "ro"
    ]
  },
  "ru": {
    "language": "ru",
    "beta": true,
    "defaultLocale": "ru",
    "availableLocale": [
      "ru"
    ]
  },
  "sl": {
    "language": "sl",
    "beta": true,
    "defaultLocale": "sl",
    "availableLocale": [
      "sl"
    ]
  },
  "sv": {
    "language": "sv",
    "beta": true,
    "defaultLocale": "sv",
    "availableLocale": [
      "sv-fi",
      "sv"
    ]
  },
  "th": {
    "language": "th",
    "beta": true,
    "defaultLocale": "th",
    "availableLocale": [
      "th"
    ]
  },
  "tr": {
    "language": "tr",
    "beta": true,
    "defaultLocale": "tr",
    "availableLocale": [
      "tr"
    ]
  },
  "uk": {
    "language": "uk",
    "beta": true,
    "defaultLocale": "uk",
    "availableLocale": [
      "uk"
    ]
  },
  "vi": {
    "language": "vi",
    "beta": true,
    "defaultLocale": "vi",
    "availableLocale": [
      "vi"
    ]
  },
  "zh-cn": {
    "language": "zh-cn",
    "beta": true,
    "defaultLocale": "zh-cn",
    "availableLocale": [
      "zh-cn"
    ]
  },
  "zh-hk": {
    "language": "zh-hk",
    "beta": true,
    "defaultLocale": "zh-hk",
    "availableLocale": [
      "zh-hk"
    ]
  }
});

hns('I18n.currencySymbols', {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "AOA": {
    "symbol": "Kz",
    "name": "Angolan kwanza",
    "symbol_native": "Kz",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AOA",
    "name_plural": "Angolan kwanzas"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLF": {
    "symbol": "UF",
    "name": "Unidad de Fomento",
    "symbol_native": "UF",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CLF",
    "name_plural": "Unidades de Fomento"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos",
    "alternative_decimal_digits": 2
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "COP",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "kr.",
    "name": "Danish Krone",
    "symbol_native": "kr.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Shekel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new shekels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "₹",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "L$",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MNT": {
    "symbol": "MNT",
    "name": "Mongolian Tughrik",
    "symbol_native": "₮",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MNT",
    "name_plural": "Mongolian tögrög"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MRO": {
    "symbol": "UM",
    "name": "Mauritanian ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 1,
    "rounding": 0,
    "code": "MRO",
    "name_plural": "Mauritanian ouguiya"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "kr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PGK": {
    "symbol": "K",
    "name": "Papua New Guinean kina",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PGK",
    "name_plural": "Papua New Guinean kina"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "SEK",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SRD": {
    "symbol": "SR$",
    "name": "Surinamese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SRD",
    "name_plural": "Surinamese dollars"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.S.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.S.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  },
  "ANG": {
    "symbol": "NAƒ",
    "name": "Netherlands Antillean Guilder",
    "symbol_native": "ƒ",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ANG",
    "name_plural": "Netherlands Antillean guilders"
  },
  "AWG": {
    "symbol": "Afl.",
    "name": "Aruban Florin",
    "symbol_native": "Afl.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AWG",
    "name_plural": "Aruban florin"
  },
  "BBD": {
    "symbol": "Bds$",
    "name": "Barbadian Dollar",
    "symbol_native": "Bds$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BBD",
    "name_plural": "Barbadian dollars"
  },
  "BMD": {
    "symbol": "BD$",
    "name": "Bermudian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BMD",
    "name_plural": "Bermudian dollars"
  },
  "BOV": {
    "symbol": "Bolivian Mvdol",
    "name": "Bolivian Mvdol",
    "symbol_native": "Bolivian Mvdol",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOV",
    "name_plural": "Bolivian Mvdol"
  },
  "BSD": {
    "symbol": "B$",
    "name": "Bahamian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BSD",
    "name_plural": "Bahamian dollars"
  },
  "BTN": {
    "symbol": "Nu.",
    "name": "Bhutanese Ngultrum",
    "symbol_native": "Nu.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BTN",
    "name_plural": "Bhutanese ngultrum"
  },
  "BYN": {
    "symbol": "Br",
    "name": "Belarusian Ruble",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BYN",
    "name_plural": "Belarusian rubles"
  },
  "CHE": {
    "symbol": "CHE",
    "name": "WIR Euro",
    "symbol_native": "CHE",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHE",
    "name_plural": "WIR Euro"
  },
  "CHW": {
    "symbol": "CHW",
    "name": "WIR Franc",
    "symbol_native": "CHW",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHW",
    "name_plural": "WIR Franc"
  },
  "COU": {
    "symbol": "COU",
    "name": "Unidad de Valor Real",
    "symbol_native": "COU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "COU",
    "name_plural": "Unidad de Valor Real"
  },
  "CUC": {
    "symbol": "CUC$",
    "name": "Cuban Convertible Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUC",
    "name_plural": "Cuban convertible pesos"
  },
  "CUP": {
    "symbol": "$",
    "name": "Cuban Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUP",
    "name_plural": "Cuban pesos"
  },
  "FJD": {
    "symbol": "FJ$",
    "name": "Fiji Dollar",
    "symbol_native": "FJ$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FJD",
    "name_plural": "Fiji dollars"
  },
  "FKP": {
    "symbol": "£",
    "name": "Falkland Islands Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FKP",
    "name_plural": "Falkland Islands pounds"
  },
  "GIP": {
    "symbol": "£",
    "name": "Gibraltar Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GIP",
    "name_plural": "Gibraltar pounds"
  },
  "GMD": {
    "symbol": "D",
    "name": "Gambian Dalasi",
    "symbol_native": "D",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GMD",
    "name_plural": "Gambian dalasi"
  },
  "GYD": {
    "symbol": "G$",
    "name": "Guyanese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GYD",
    "name_plural": "Guyanese dollars"
  },
  "HTG": {
    "symbol": "G",
    "name": "Haitian Gourde",
    "symbol_native": "G",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HTG",
    "name_plural": "Haitian gourdes"
  },
  "KGS": {
    "symbol": "C",
    "name": "Kyrgyzstani Som",
    "symbol_native": "C",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KGS",
    "name_plural": "Kyrgyzstani som"
  },
  "KPW": {
    "symbol": "₩",
    "name": "North Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KPW",
    "name_plural": "North Korean won"
  },
  "KYD": {
    "symbol": "CI$",
    "name": "Cayman Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KYD",
    "name_plural": "Cayman Islands dollars"
  },
  "LAK": {
    "symbol": "₭",
    "name": "Lao Kip",
    "symbol_native": "₭",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LAK",
    "name_plural": "Lao kip"
  },
  "LRD": {
    "symbol": "L$",
    "name": "Liberian Dollar",
    "symbol_native": "L$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LRD",
    "name_plural": "Liberian dollars"
  },
  "LSL": {
    "symbol": "M",
    "name": "Lesotho Loti",
    "symbol_native": "M",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LSL",
    "name_plural": "Lesotho maloti"
  },
  "MRU": {
    "symbol": "UM",
    "name": "Mauritanian Ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MRU",
    "name_plural": "Mauritanian ouguiya"
  },
  "MVR": {
    "symbol": "Rf",
    "name": "Maldivian Rufiyaa",
    "symbol_native": "Rf",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MVR",
    "name_plural": "Maldivian rufiyaa"
  },
  "MWK": {
    "symbol": "K",
    "name": "Malawian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MWK",
    "name_plural": "Malawian kwacha"
  },
  "MXV": {
    "symbol": "MXV",
    "name": "Mexican Unidad de Inversión",
    "symbol_native": "MXV",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXV",
    "name_plural": "Mexican unidad de inversión"
  },
  "SBD": {
    "symbol": "SI$",
    "name": "Solomon Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SBD",
    "name_plural": "Solomon Islands dollars"
  },
  "SCR": {
    "symbol": "SR",
    "name": "Seychellois Rupee",
    "symbol_native": "SR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SCR",
    "name_plural": "Seychellois rupees"
  },
  "SHP": {
    "symbol": "£",
    "name": "Saint Helena Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SHP",
    "name_plural": "Saint Helena pounds"
  },
  "SLL": {
    "symbol": "Le",
    "name": "Sierra Leonean Leone",
    "symbol_native": "Le",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SLL",
    "name_plural": "Sierra Leonean leones"
  },
  "SSP": {
    "symbol": "SSP",
    "name": "South Sudanese Pound",
    "symbol_native": "SSP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SSP",
    "name_plural": "South Sudanese pounds"
  },
  "STN": {
    "symbol": "Db",
    "name": "São Tomé and Príncipe Dobra",
    "symbol_native": "Db",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "STN",
    "name_plural": "São Tomé and Príncipe dobras"
  },
  "SVC": {
    "symbol": "₡",
    "name": "Salvadoran Colón",
    "symbol_native": "₡",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SVC",
    "name_plural": "Salvadoran colones"
  },
  "SZL": {
    "symbol": "E",
    "name": "Swazi Lilangeni",
    "symbol_native": "E",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SZL",
    "name_plural": "Swazi emalangeni"
  },
  "TJS": {
    "symbol": "TJS",
    "name": "Tajikistani Somoni",
    "symbol_native": "TJS",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TJS",
    "name_plural": "Tajikistani somoni"
  },
  "TMT": {
    "symbol": "T",
    "name": "Turkmenistan Manat",
    "symbol_native": "T",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TMT",
    "name_plural": "Turkmenistan manat"
  },
  "USN": {
    "symbol": "$",
    "name": "US dollar (Next day)",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USN",
    "name_plural": "US dollar (next day)"
  },
  "UYI": {
    "symbol": "UYI",
    "name": "Uruguay Peso en Unidades Indexadas",
    "symbol_native": "UYI",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYI",
    "name_plural": "Uruguay Peso en Unidades Indexadas"
  },
  "VUV": {
    "symbol": "VT",
    "name": "Vanuatu Vatu",
    "symbol_native": "VT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VUV",
    "name_plural": "Vanuatu vatu"
  },
  "WST": {
    "symbol": "WS$",
    "name": "Samoan Tālā",
    "symbol_native": "WS$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "WST",
    "name_plural": "Samoan tālā"
  },
  "XAG": {
    "symbol": "XAG",
    "name": "Silver",
    "symbol_native": "XAG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAG",
    "name_plural": "Silver"
  },
  "XAU": {
    "symbol": "XAU",
    "name": "Gold",
    "symbol_native": "XAU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAU",
    "name_plural": "Gold"
  },
  "XBA": {
    "symbol": "XBA",
    "name": "Bond Markets Unit European Composite Unit (EURCO)",
    "symbol_native": "XBA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBA",
    "name_plural": "Bond Markets Unit European Composite Unit (EURCO)"
  },
  "XBB": {
    "symbol": "XBB",
    "name": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    "symbol_native": "XBB",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBB",
    "name_plural": "Bond Markets Unit European Monetary Unit (E.M.U.-6)"
  },
  "XBC": {
    "symbol": "XBC",
    "name": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)9",
    "symbol_native": "XBC",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBC",
    "name_plural": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)"
  },
  "XBD": {
    "symbol": "XBD",
    "name": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    "symbol_native": "XBD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBD",
    "name_plural": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)"
  },
  "XCD": {
    "symbol": "$",
    "name": "East Caribbean Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XCD",
    "name_plural": "East Caribbean Dollar"
  },
  "XDR": {
    "symbol": "SDR",
    "name": "SDR (Special Drawing Right)",
    "symbol_native": "SDR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XDR",
    "name_plural": "SDR (Special Drawing Right)"
  },
  "XPD": {
    "symbol": "XPD",
    "name": "Palladium",
    "symbol_native": "XPD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPD",
    "name_plural": "Palladium"
  },
  "XPF": {
    "symbol": "CFP",
    "name": "CFP Franc",
    "symbol_native": "CFP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPF",
    "name_plural": "CFP franc"
  },
  "XPT": {
    "symbol": "XPT",
    "name": "Platinum",
    "symbol_native": "XPT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPT",
    "name_plural": "Platinum"
  },
  "XSU": {
    "symbol": "XSU",
    "name": "SUCRE",
    "symbol_native": "XSU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XSU",
    "name_plural": "SUCRE"
  },
  "XUA": {
    "symbol": "XUA",
    "name": "ADB Unit of Account",
    "symbol_native": "XUA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XUA",
    "name_plural": "ADB Unit of Account"
  },
  "ZMW": {
    "symbol": "K",
    "name": "Zambian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZMW",
    "name_plural": "Zambian kwacha"
  },
  "ZWL": {
    "symbol": "Z$",
    "name": "Zimbabwe Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZWL",
    "name_plural": "Zimbabwe dollar"
  }
});

"use strict";
'use es6';
'babel noModule';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var ABBREVIATE_DEFAULTS = {
    type: 'short',
    precision: 0
  }; // htmlEscape utility function based on Underscore's _.escape

  var htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var htmlCharPattern = '(?:&|<|>|"|\'|`)';
  var htmlTestRegexp = RegExp(htmlCharPattern);
  var htmlReplaceRegexp = RegExp(htmlCharPattern, 'g');

  var htmlReplacement = function htmlReplacement(match) {
    return htmlEscapeMap[match];
  };

  var htmlEscape = function htmlEscape(string) {
    if (htmlTestRegexp.test(string)) {
      return string.replace(htmlReplaceRegexp, htmlReplacement);
    } else {
      return string;
    }
  };

  I18n.baseI18nT = I18n.t;

  I18n.text = I18n.t = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var lastOption = args[args.length - 1];
    var includesOptions = typeof lastOption !== 'string';
    var originalOpts = includesOptions && lastOption ? args[args.length - 1] : {};
    var key = includesOptions ? args.slice(0, args.length - 1).join('.') : args.join('.');
    var modifiedOpts = {}; // Copy originalOpts to modifiedOpts, formatting numeric params and escaping others along the way

    for (var optName in originalOpts) {
      if (originalOpts.hasOwnProperty(optName)) {
        var optValue = originalOpts[optName];

        if (optValue != null) {
          modifiedOpts[optName] = I18n.formatParam(optName, optValue);
        }
      }
    }

    if (!modifiedOpts.locale && I18n.lang !== 'en' && !I18n.langEnabled && !I18n.publicPage) {
      I18n.debugLog('Forcing translation in English, lang is not enabled');
      modifiedOpts.locale = 'en';
    } // Attach the translation key to the options object for missingPlaceholder


    modifiedOpts.__scope = key; // Warn if I18n isn't ready yet (#296)

    if (I18n.fired && !I18n.fired.ready) {
      var tooEarlyError = new Error("I18n.text called before ready with key '" + key + "' - See go/i18n-help for more info");
      setTimeout(function () {
        throw tooEarlyError;
      }, 0);
    }

    return I18n.baseI18nT(key, modifiedOpts);
  }; // NOTE: re-implemented in ./react-helpers.js, keep in sync


  I18n.html = function (key, opts) {
    if (opts == null) {
      opts = {};
    }

    var gap = '';

    if (opts.useGap === true || opts.noGap === false) {
      gap = ' ';
    }

    return gap + "<i18n-string data-key='" + key + "' data-locale-at-render='" + I18n.locale + "'>" + I18n.text(key, opts) + "</i18n-string>" + gap;
  };

  I18n.formatNumber = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    if (opts.abbreviate) {
      opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);

      if (typeof opts.abbreviate === 'string') {
        opts.type = opts.abbreviate;
      }

      return I18n.abbreviateNumber(val, opts);
    }

    return I18n.toNumber(val, opts);
  };

  I18n.formatPercentage = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    return I18n.toPercentage(val, opts);
  };

  I18n.formatCurrency = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    if (!I18n.currencySymbols['USD']) {
      console.error('It looks like currency data is not available. Are you using the new I18n loader and forgot to import currencies? See go/new-i18n');
    }

    if (opts.currencyCode) {
      var currencyData = I18n.currencySymbols[opts.currencyCode];

      if (currencyData) {
        if (opts.unit == null) {
          opts.unit = currencyData.symbol;
        }

        var decimalDigits = currencyData.decimal_digits;

        if (currencyData.alternative_decimal_digits && val % 1 !== 0) {
          decimalDigits = currencyData.alternative_decimal_digits;
        }

        if (opts.precision == null) {
          opts.precision = decimalDigits;
        }
      }
    }

    if (!opts.unit && !opts.useCurrencyCode) {
      console.warn('I18n: Missing or invalid currencyCode in call to formatCurrency. See https://git.hubteam.com/HubSpot/I18n/issues/59');
    }

    if (opts.abbreviate) {
      opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);

      if (typeof opts.abbreviate === 'string') {
        opts.type = opts.abbreviate;
      } // Format an arbitrary number and replace it with the abbreviation, to preserve the sign/unit order


      var signedNumber = val >= 0 ? 2 : -2;
      return I18n.toCurrency(signedNumber, opts).replace('2', I18n.abbreviateNumber(Math.abs(val), opts));
    } else {
      return I18n.toCurrency(val, opts);
    }
  };

  I18n.formatSize = I18n.toHumanSize;
  var NUMERAL_OR_SIGN_OR_E = /\d|\+|-|e/i;

  I18n.parseNumber = function (string, options) {
    options = I18n.prepareOptions(options, I18n.lookup('number.format', {
      locale: (options || {}).locale
    }), I18n.NUMBER_FORMAT);

    if (typeof string === 'number') {
      return string;
    } else if (typeof string !== 'string') {
      return NaN;
    } // Remove all whitespace and replace first instance of MINUS SIGN with HYPHEN MINUS


    string = string.replace(/\s/g, '').replace('−', '-'); // Iterate through all characters in the string and return NaN if we encounter an invalid character

    var buffer = '';

    for (var _i = 0, _Array$from = Array.from(string); _i < _Array$from.length; _i++) {
      var char = _Array$from[_i];

      if (char.match(NUMERAL_OR_SIGN_OR_E)) {
        buffer += char;
      } else if (char === options.separator) {
        buffer += '.';
      } else if (char === options.delimiter) {
        continue;
      } else {
        return NaN;
      }
    } // Attempt to parse what's left


    return parseFloat(buffer);
  };

  I18n.missingNotifications = [];

  var missingNotificationWrapper = function missingNotificationWrapper(originalFunction, eventName, sendSentries, originalArgs, sentryOptions) {
    if (sentryOptions == null) {
      sentryOptions = {};
    }

    var message = originalFunction.apply(I18n, originalArgs);
    var sentryMessage = sentryOptions.message || message;

    if (I18n.missingNotifications.indexOf(sentryMessage) < 0) {
      I18n.missingNotifications.push(sentryMessage);
      var missingNoticationError = new Error("I18n: " + sentryMessage);
      var extraErrorMetadata = {
        i18nErrorType: eventName,
        currentLocale: I18n.langEnabled ? I18n.locale : 'en-us',
        translationKey: sentryOptions.translationKey,
        placeholderName: sentryOptions.placeholderName
      };

      if (window.newrelic) {
        window.newrelic.noticeError(missingNoticationError, extraErrorMetadata);
      }

      if (sendSentries && window.Raven) {
        window.Raven.captureException(missingNoticationError, {
          extra: extraErrorMetadata
        });
      }

      try {
        if (localStorage.getItem('TRACK_I18N_MISSING_TRANSLATIONS')) {
          localStorage.setItem('I18N_MISSING_TRANSLATIONS', I18n.missingNotifications);
        }
      } catch (e) {//ignore
      }
    } // Trigger event if in browser context (trigger not currently around in node/schablone)


    if (typeof I18n.trigger === 'function') {
      I18n.trigger(eventName, message);
    }

    return message;
  };

  I18n.sendSentryOnMissingTranslations = true;
  var originalMissingTranslation = I18n.missingTranslation;

  I18n.missingTranslation = function (scope) {
    var missingTranslationMessage = 'Missing translation: "' + scope + '"';
    console.warn("I18n: " + missingTranslationMessage);
    var sentryOptions = {
      translationKey: scope,
      message: missingTranslationMessage
    };
    return htmlEscape(missingNotificationWrapper(originalMissingTranslation, 'missingTranslation', I18n.sendSentryOnMissingTranslations, [scope], sentryOptions));
  };

  I18n.sendSentryOnMissingValues = true;
  var originalMissingValue = I18n.missingPlaceholder;

  I18n.missingPlaceholder = function (placeholder, message, options) {
    var missingPlaceholderMessage = "Missing placeholder: " + placeholder + " in \"" + options.__scope + "\"";
    var sentryOptions = {
      message: missingPlaceholderMessage,
      translationKey: options.__scope,
      placeholderName: placeholder
    };
    console.warn("I18n: " + missingPlaceholderMessage);
    return missingNotificationWrapper(originalMissingValue, 'missingPlaceholder', I18n.sendSentryOnMissingValues, [placeholder, message, options], sentryOptions);
  };

  if (I18n.lang == null) {
    Object.defineProperty(I18n, 'lang', {
      get: function get() {
        return I18n.locale.split('-')[0];
      }
    });
  } // Performs "oxford comma"-style list joining according to each locale's settings.
  // Based off the Rails `Array#to_sentence` function.
  //
  //    I18n.formatList([1,2,3])  # => "1, 2, and 3"
  //    I18n.formatList([1,2,3], { locale: 'ja' })  // => "1と2と3"
  //
  //    I18n.formatList([1,2], {
  //      twoWordsConnector: '  AND  '
  //    })  // => "1  AND  2"
  //
  //    I18n.formatList([1,2,3], {
  //      wordsConnector: '|'
  //    })  // => "1|2, and 3"
  //
  //    I18n.formatList([1,2,3], {
  //      wordsConnector: '|',
  //      lastWordConnector: '&&&'
  //    })  // => "1|2&&&3"
  //
  //    // And assuming that the `foo.bar` key is defined like this...
  //    //
  //    //  en:
  //    //    foo:
  //    //      bar:
  //    //        one: {{ count }} other
  //    //        other: {{ count }} others
  //
  //    I18n.formatList([1,2,3,4,5], {
  //      limit: 4,
  //      excessKey: 'foo.bar'
  //    });  // => " 1, 2, 3, and 1 other"
  //
  //    I18n.formatList([1,2,3,4,5], {
  //      limit: 3,
  //      excessKey: 'foo.bar'
  //    });  // => " 1, 2, 3, and 2 others"
  //


  var CONNECTOR_DEFAULTS = {
    inclusive: {
      wordsConnector: '|, ',
      twoWordsConnector: '| and ',
      lastWordConnector: '|, and '
    },
    exclusive: {
      wordsConnector: '|, ',
      twoWordsConnector: '| or ',
      lastWordConnector: '|, or '
    }
  };

  var interleave = function interleave(between, items) {
    var lastIndex = items.length - 1;
    return items.reduce(function (acc, item, index) {
      acc.push(item);

      if (index !== lastIndex) {
        acc.push(between);
      }

      return acc;
    }, []);
  };

  I18n.formatListArray = function (list, options) {
    var result;

    if (options == null) {
      options = {};
    }

    var _options = options,
        wordsConnector = _options.wordsConnector,
        twoWordsConnector = _options.twoWordsConnector,
        lastWordConnector = _options.lastWordConnector,
        limit = _options.limit,
        excessKey = _options.excessKey,
        exclusive = _options.exclusive;

    if (limit != null && limit <= 2) {
      throw new Error('The formatList limit must be 3 or larger');
    }

    if (limit != null && excessKey == null) {
      throw new Error('When using a limit in formatList, you must pass excessKey (that is a external, plurlized string reference)');
    }

    if (Array.isArray != null) {
      // Hack to use Array.isArray in a node envionment (since instanceof check won't work for arrays
      // created across vm/context boundaries)
      if (!Array.isArray(list)) {
        throw new Error('The first argument to I18n.formatList must be an array');
      }
    } else {
      if (!(list instanceof Array)) {
        throw new Error('The first argument to I18n.formatList must be an array');
      }
    } // Use passed options, then config for the locale, then defaults if missing


    var rootKey = 'number.human.array';
    var connectorType = 'inclusive';

    if (exclusive === true) {
      connectorType = 'exclusive';
    }

    wordsConnector = options.wordsConnector || I18n.text(rootKey + "." + connectorType + ".wordsConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].wordsConnector;
    twoWordsConnector = options.twoWordsConnector || I18n.text(rootKey + "." + connectorType + ".twoWordsConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].twoWordsConnector;
    lastWordConnector = options.lastWordConnector || I18n.text(rootKey + "." + connectorType + ".lastWordConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].lastWordConnector;
    var length = list.length;

    if (length === 0) {
      return [];
    } else if (length === 1) {
      return [list[0]];
    } else if (length === 2) {
      return [list[0], twoWordsConnector, list[1]];
    } else if (limit == null || limit >= length) {
      result = interleave(wordsConnector, list.slice(0, -1));
      result.push(lastWordConnector);
      result.push(list[list.length - 1]);
      return result;
    } else {
      var excessString = I18n.text(excessKey, {
        count: list.length - limit,
        locale: options.locale
      });
      result = interleave(wordsConnector, list.slice(0, limit));
      result.push(lastWordConnector);
      result.push(excessString);
      return result;
    }
  };

  I18n.formatList = function (list, options) {
    if (options == null) {
      options = {};
    }

    return I18n.formatListArray(list, options).join('');
  };

  var ABBR_DIGIT_MAX = 15;
  var ABBR_NUMBER_MAX = Math.pow(10, ABBR_DIGIT_MAX);
  var ABBR_NUMBER_MIN = 1000; // Short number helpers (they use patterns set in `<locale>.human.abbreviated.(short|long)`)
  //
  // Standard options:
  //   - **locale**: sets the locale to use for formatting (defaults to current `I18n.locale`)
  //   - **separator**: overrides the separator—character between int and decimal digits—from the above locale
  //   - **delimiter**: overrides the delimiter—character between every 3 int digits—from the above locale
  // Advanced options (mostly borrowed from the Intl.NumberFormat spec):
  //   - **minIntegerDigits**: the minimum number of integer digits—digits to the left of the decimal—to show (default is 1). Use this to left pad integers, like `00001`
  //   - **minFractionDigits**: the minimum number of fractional digits—digits to the right of the decimal—to show (default is 0)
  //   - **maxFractionDigits**: the maximum number of fractional digits—digits to the right of the decimal—to show (default is `max(minFractionDigits, 0)`)
  //   - **minSignificantDigits**: the minimum number of any non-zersignficant digits to show (default is undefined or 1 if maxSignificantDigits is set)
  //   - **maxSignificantDigits**: the maximum number of any signficant digits to show (default is undefined or <large number> if minSignificantDigits is set)
  //   - **numDigitsToTruncateTo**: the desired number of integer digits. Cuts of the rest of the digits rounding up if needed (default is undefined)
  //   - **stripInsignificantZeros**: remove all 0 decimal digits that at end (default is true unless any min/max fraction/significant digit option is set)

  I18n.advancedFormatNumber = function (number, opts) {
    var formattedNumber;

    if (opts == null) {
      opts = {};
    }

    opts = this.prepareOptions(opts, I18n.lookup('number.format', {
      locale: opts.locale
    }), {
      separator: '.',
      delimiter: ','
    });
    var _opts = opts,
        separator = _opts.separator,
        delimiter = _opts.delimiter,
        numDigitsToTruncateTo = _opts.numDigitsToTruncateTo,
        maxThreshold = _opts.maxThreshold,
        minThreshold = _opts.minThreshold,
        minIntegerDigits = _opts.minIntegerDigits,
        maxSignificantDigits = _opts.maxSignificantDigits,
        minSignificantDigits = _opts.minSignificantDigits,
        maxFractionDigits = _opts.maxFractionDigits,
        minFractionDigits = _opts.minFractionDigits,
        stripInsignificantZeros = _opts.stripInsignificantZeros; // SET DEFAULTS

    var negative = number < 0; // Threshold for when a number should be truncated/abbreviated

    if (minThreshold == null) {
      minThreshold = Number.NEGATIVE_INFINITY;
    }

    if (maxThreshold == null) {
      maxThreshold = Number.POSITIVE_INFINITY;
    } // Default to not stripping zeros if any advanced formatting is passed


    if (minFractionDigits != null || minSignificantDigits != null || maxFractionDigits != null || maxSignificantDigits != null) {
      if (stripInsignificantZeros == null) {
        stripInsignificantZeros = false;
      }
    } else {
      if (stripInsignificantZeros == null) {
        stripInsignificantZeros = true;
      }
    } // Set higher than numDigits for zero-padded small numbers


    if (minIntegerDigits == null) {
      minIntegerDigits = Math.max(numDigitsToTruncateTo != null ? numDigitsToTruncateTo : 0, 1);
    } // Control the total number signficant digits (includes both fractional
    // and not fractional digits). No defaults unless one of the two is set


    if (minSignificantDigits != null || maxSignificantDigits != null) {
      if (maxSignificantDigits == null) {
        maxSignificantDigits = ABBR_DIGIT_MAX;
      }

      if (minSignificantDigits == null) {
        minSignificantDigits = 1;
      }
    } // Control the number of fractional digits


    if (minFractionDigits == null) {
      minFractionDigits = 0;
    }

    if (maxFractionDigits == null) {
      maxFractionDigits = Math.max(minFractionDigits, 0);
    } // CALCULATE FORMATTING


    var absNumber = Math.abs(number);

    if (numDigitsToTruncateTo != null && minThreshold <= absNumber && absNumber < maxThreshold) {
      var truncateFactor = Math.max(0, I18n.util.log10Floor(absNumber) + 1 - numDigitsToTruncateTo);
      absNumber = absNumber / Math.pow(10, truncateFactor);
    }

    if (minSignificantDigits != null && maxSignificantDigits != null) {
      formattedNumber = I18n.util.toRawPrecision(absNumber, minSignificantDigits, maxSignificantDigits);
    } else {
      formattedNumber = I18n.util.toRawFixed(absNumber, minIntegerDigits, minFractionDigits, maxFractionDigits);
    } // AND THEN LOCALIZE


    var parts = formattedNumber.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var buffer = [];

    while (intPart.length > 0) {
      buffer.unshift(intPart.substr(Math.max(0, intPart.length - 3), 3));
      intPart = intPart.substr(0, intPart.length - 3);
    }

    var localizedNumber = buffer.join(delimiter);

    if (stripInsignificantZeros && decPart) {
      decPart = decPart.replace(/0+$/, '');
    }

    if (decPart) {
      localizedNumber += separator + decPart;
    }

    if (negative) {
      localizedNumber = "\u2212" + localizedNumber;
    }

    return localizedNumber;
  };

  var getAbbreviationKey = function getAbbreviationKey(number) {
    number = Math.abs(number);

    var zeroes = _toConsumableArray(Array(Math.floor(number).toString().length - 1).keys()).map(function () {
      return '0';
    }).join('');

    return "1" + zeroes;
  };

  var parseAbbreviatePattern = function parseAbbreviatePattern(pattern) {
    var match = pattern.match(/^([^0]*)(0+)(.*)$/);

    if (match) {
      var _match = _slicedToArray(match, 4),
          __ = _match[0],
          prefix = _match[1],
          digitString = _match[2],
          suffix = _match[3];

      var numDigits = digitString.length;
      return {
        prefix: prefix,
        digitString: digitString,
        numDigits: numDigits,
        suffix: suffix
      };
    } else {
      throw new Error("Invalid abbreviation pattern: " + pattern);
    }
  };

  I18n.abbreviateNumber = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    var _opts2 = opts,
        type = _opts2.type,
        locale = _opts2.locale,
        separator = _opts2.separator,
        delimiter = _opts2.delimiter,
        stripInsignificantZeros = _opts2.stripInsignificantZeros,
        minIntegerDigits = _opts2.minIntegerDigits,
        maxSignificantDigits = _opts2.maxSignificantDigits,
        minSignificantDigits = _opts2.minSignificantDigits,
        maxFractionDigits = _opts2.maxFractionDigits,
        minFractionDigits = _opts2.minFractionDigits;

    if (type == null) {
      type = 'short';
    } // or 'long'


    var key = getAbbreviationKey(val);
    var abbrPattern = I18n.lookup("number.human.abbreviated." + type + "." + key, opts); // Deal with pluralizing (just take the first plural pattern and use it to determine pluralization)

    if (abbrPattern != null && typeof abbrPattern === 'object') {
      var samplePatternString = abbrPattern[Object.keys(abbrPattern)[0]];
      var samplePattern = parseAbbreviatePattern(samplePatternString);
      var sampleTruncatedNumber = I18n.advancedFormatNumber(val, {
        numDigitsToTruncateTo: samplePattern.numDigits,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX
      });
      var pluralizer = I18n.pluralization.get(locale);
      var pluralKeys = pluralizer(Math.abs(sampleTruncatedNumber));

      while (pluralKeys.length) {
        var pluralKey = pluralKeys.shift();

        if (abbrPattern[pluralKey] != null) {
          abbrPattern = abbrPattern[pluralKey];
          break;
        }
      }
    } // If this locale is unable to truncate for this number size, set
    // numDigits to a high value to prevent any truncation from happening


    if (['0', 0].includes(abbrPattern) || abbrPattern == null) {
      return I18n.advancedFormatNumber(val, {
        locale: locale,
        numDigitsToTruncateTo: 30,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX,
        minIntegerDigits: minIntegerDigits != null ? minIntegerDigits : 1,
        // Need to set so it doesn't default to the large numDigitsToTruncateTo value
        minSignificantDigits: minSignificantDigits,
        maxSignificantDigits: maxSignificantDigits,
        minFractionDigits: minFractionDigits,
        maxFractionDigits: maxFractionDigits,
        separator: separator,
        delimiter: delimiter,
        stripInsignificantZeros: stripInsignificantZeros
      }); // Otherwise, truncate normally
    } else {
      var abbrFormat = parseAbbreviatePattern(abbrPattern);
      var formattedTruncatedNumber = I18n.advancedFormatNumber(val, {
        locale: locale,
        numDigitsToTruncateTo: abbrFormat.numDigits,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX,
        minIntegerDigits: minIntegerDigits,
        minSignificantDigits: minSignificantDigits,
        maxSignificantDigits: maxSignificantDigits,
        minFractionDigits: minFractionDigits,
        maxFractionDigits: maxFractionDigits,
        separator: separator,
        delimiter: delimiter,
        stripInsignificantZeros: stripInsignificantZeros
      });
      return "" + abbrFormat.prefix + formattedTruncatedNumber + abbrFormat.suffix;
    }
  }; // interpolateToArray function to translate strings while preserving React element params (#108)


  I18n.interpolateToArray = function (key, options, escapeFunction) {
    var modifiedOpts = I18n.prepareOptions(options);
    modifiedOpts.__scope = key;
    var result = [];

    if (!options.locale && !I18n.langEnabled && !I18n.publicPage) {
      I18n.debugLog('Forcing translation in English, lang is not enabled');
      modifiedOpts.locale = 'en';
    }

    var remainingMessage = I18n.lookup(key, modifiedOpts);

    if (remainingMessage == null) {
      return [I18n.missingTranslation(key)];
    }

    if (remainingMessage === Object(remainingMessage) && this.isSet(options.count)) {
      if (options.count === 0 && remainingMessage.zero) {
        remainingMessage = remainingMessage.zero;
      } else if (options.count === 1 && remainingMessage.one) {
        remainingMessage = remainingMessage.one;
      } else {
        remainingMessage = remainingMessage.other;
      }
    }

    var i = 0;
    var match = I18n.placeholder.exec(remainingMessage);

    while (match) {
      // Custom HubSpot change for default escaping of params
      var prefix = remainingMessage.substring(0, match.index);

      if (prefix !== '') {
        result.push(escapeFunction('text-chunk', prefix, i++));
      }

      var optName = match[1];
      var rawOptValue = modifiedOpts[optName] != null ? modifiedOpts[optName] : I18n.missingPlaceholder(optName, remainingMessage, modifiedOpts);
      var escapedOptValue = escapeFunction(optName, rawOptValue, i++);

      if (escapedOptValue !== '') {
        result.push(escapedOptValue);
      }

      remainingMessage = remainingMessage.substring(match.index + match[0].length); // Reset `lastIndex` because we are re-using the same regex (and it maintains state when doing `exec`)

      I18n.placeholder.lastIndex = 0;
      match = I18n.placeholder.exec(remainingMessage);
    }

    if (remainingMessage !== '') {
      result.push(escapeFunction('text-chunk', remainingMessage, i++));
    }

    return result;
  }; // formatParam function to turn SafeStrings into strings, HTML-escape string primitives, and format numbers


  I18n.formatParam = function (optName, optValue) {
    if (typeof optValue === 'number') {
      if (isNaN(optValue)) {
        return null; // don't display NaN
      }

      if (optName === 'count') {
        return Number(optValue);
      }

      if (optName.toLowerCase() === 'portalid') {
        console.warn('The use of params named "portalId" in externalized strings is deprecated. You should wrap it, like so "I18n.t(key, { portalId: I18n.SafeString(portalId) })", to prevent it from being automatically formatted. See HubSpot/I18n#109');
        return String(optValue);
      } else {
        return I18n.formatNumber(optValue);
      }
    } else if (optValue instanceof I18n.SafeString) {
      return optValue.toString();
    } else if (optValue != null) {
      return htmlEscape(String(optValue));
    } else {
      return optValue;
    }
  };

  var zeroAsOnePlural = function zeroAsOnePlural(count) {
    var validCount = count === 0 ? 1 : count;
    return I18n.pluralization.default(validCount);
  };

  I18n.pluralization.fr = zeroAsOnePlural;
})();

(function () {
var DATE_STRING_ZONE_ABBR_REGEX, INTL_STRING_ZONE_ABBR_REGEX, origZoneAbbr, userZoneAbbr,
  slice = [].slice;

INTL_STRING_ZONE_ABBR_REGEX = /\s+(\S+)$/;

DATE_STRING_ZONE_ABBR_REGEX = /[A-Z]{2}\S+/;

I18n.moment.fn.portalTz = function() {
  var args, moment;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length === 0) {
    moment = I18n.moment.fn.tz.call(this, I18n.timezone);
  } else {
    throw new Error("You cannot pass any parameters to portalTz when called on a moment instance. Did you mean to call `I18n.moment.portalTz(...)` instead?");
  }
  return moment;
};

I18n.moment.portalTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment.tz).call.apply(ref, [this].concat(slice.call(args), [I18n.timezone]));
  } else {
    moment = I18n.moment.utc().tz(I18n.timezone);
  }
  return moment;
};

I18n.moment.userTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment).call.apply(ref, [this].concat(slice.call(args)));
  } else {
    moment = I18n.moment();
  }
  moment.zoneAbbr = userZoneAbbr;
  return moment;
};

origZoneAbbr = I18n.moment.fn.zoneAbbr;

I18n.moment.fn.zoneAbbr = function() {
  if (this._z === void 0) {
    console.warn('I18n: Time zone abbreviations are not available on moments created with I18n.moment(). Switch to I18n.moment.userTz(), I18n.moment.portalTz(), or I18n.moment.utc(), as appropriate: https://git.hubteam.com/HubSpot/I18n/blob/master/docs/dates.md');
  }
  return origZoneAbbr.call(this);
};

userZoneAbbr = function() {
  var date, match;
  date = this.toDate();
  I18n.intlTimeZoneFormatter || (I18n.intlTimeZoneFormatter = typeof Intl !== "undefined" && Intl !== null ? typeof Intl.DateTimeFormat === "function" ? Intl.DateTimeFormat('en', {
    timeZoneName: 'short'
  }) : void 0 : void 0);
  if (I18n.intlTimeZoneFormatter) {
    match = I18n.intlTimeZoneFormatter.format(date).match(INTL_STRING_ZONE_ABBR_REGEX);
    if (match && match[1]) {
      return match[1];
    }
  }
  match = date.toString().match(DATE_STRING_ZONE_ABBR_REGEX);
  if (match) {
    return match[0];
  }
  return '';
};
}());

"use strict";
'use es6';
'babel noModule';

(function () {
  I18n.formatDuration = function (duration) {
    console.warn('I18n.formatDuration is deprecated and will be removed from future I18n versions. Please move to the util in I18n/utils/formatRelativeDuration');
    var minutes = Math.floor(duration.asMinutes());
    var hours = Math.floor(duration.asHours());

    if (minutes < 60) {
      return I18n.text('i18n.duration.minutes', {
        minutes: minutes
      });
    }

    if (minutes % 60 === 0) {
      return I18n.text('i18n.duration.hours', {
        hours: hours
      });
    }

    return I18n.text('i18n.duration.hoursAndMinutes', {
      hours: hours,
      minutes: minutes % 60
    });
  };
})();

"use strict";
'use es6';
'babel noModule';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var _this = this;

  I18n.partial = function () {
    var _I18n$partial;

    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var result = function result() {
      var _I18n;

      for (var _len2 = arguments.length, nextKeys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextKeys[_key2] = arguments[_key2];
      }

      var allKeys = [].concat(keys, nextKeys);
      return (_I18n = I18n).text.apply(_I18n, _toConsumableArray(allKeys));
    };

    result.partial = (_I18n$partial = I18n.partial).bind.apply(_I18n$partial, [_this].concat(keys));
    return result;
  };
})();

(function () {
var slice = [].slice;

I18n.when('locale:loaded locale:failed locale:noop', function() {
  return I18n.trigger('locale:ready');
});

I18n.when('timezone:loaded timezone:failed timezone:noop', function() {
  return I18n.trigger('timezone:ready');
});

I18n.waitFor = function() {
  var deps, pro;
  deps = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  pro = new I18n.Promise;
  I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return pro.resolve();
      });
    }, deps);
  });
  return pro;
};

I18n.loadedProjects = function() {
  var project, results;
  results = [];
  for (project in I18n.translationsLoaded) {
    results.push(project);
  }
  return results;
};

I18n.whenDOMContentLoaded(function() {
  var keys;
  keys = I18n.loadedProjects();
  return I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return I18n.trigger('ready');
      });
    }, null, I18n.langEnabled);
  });
}, false);

I18n.whenDOMContentLoaded(function() {
  var timeout;
  timeout = setTimeout(function() {
    console.error("I18n locale / timezone loading timed out");
    I18n.trigger('timeout');
    return I18n.trigger('ready');
  }, 2500);
  return I18n.when('ready', function() {
    return clearTimeout(timeout);
  });
}, false);
}());

(function () {
var pending;

I18n.buildStaticPath = function(project, path) {
  var message, ref, ref1, versionForProject;
  if ((typeof hubspot !== "undefined" && hubspot !== null ? (ref = hubspot.bender) != null ? ref.staticDomainPrefix : void 0 : void 0) == null) {
    message = "I18n error: it doesn't seem like the bender mixin has been included on the page";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else if (!(typeof I18n !== "undefined" && I18n !== null ? (ref1 = I18n.translationsAvailable[project]) != null ? ref1.en : void 0 : void 0)) {
    message = "I18n error: no translation strings are available for '" + project + "'";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else {
    versionForProject = I18n.translationsAvailable[project].en;
    return hubspot.bender.staticDomainPrefix + "/" + project + "/" + versionForProject + path;
  }
};

I18n.buildLocalePath = function(project, lang) {
  return I18n.buildStaticPath(project, "/lang/" + lang + ".js");
};

pending = {};

I18n.loadProjectLocale = function(project, locale, successCb, failureCb) {
  var fail, localeLowercased, localeMinusRegion, localeOrLangToLoad, script, success;
  if (pending[project] == null) {
    pending[project] = {};
  }
  if (pending[project][locale] != null) {
    pending[project][locale].successCallbacks.push(successCb);
    pending[project][locale].failureCallbacks.push(failureCb);
    return;
  }
  pending[project][locale] = {
    successCallbacks: [successCb],
    failureCallbacks: [failureCb]
  };
  localeLowercased = locale.toLowerCase();
  localeMinusRegion = localeLowercased.split('-')[0];
  fail = function() {
    var callbacks, i, len, message, results;
    if (localeMinusRegion !== localeLowercased) {
      message = "Locale " + locale + " (or lang " + localeMinusRegion + ") strings not available in project " + project + ", bailing";
    } else {
      message = "Lang " + locale + " strings not available in project " + project + ", bailing";
    }
    console.warn(message);
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  };
  success = function(successInfo) {
    var callbacks, i, len, results;
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb(successInfo) : void 0);
    }
    return results;
  };
  if (!I18n.translationsAvailable && !I18n.translationsAvailable[project]) {
    return fail();
  }
  if (I18n.translationsAvailable[project][localeLowercased]) {
    localeOrLangToLoad = localeLowercased;
  } else if (I18n.translationsLoaded[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those (and they are already loaded).");
    return success({
      alreadyPresent: true
    });
  } else if (I18n.translationsAvailable[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those.");
    localeOrLangToLoad = localeMinusRegion;
  } else {
    return fail();
  }
  if (!localeOrLangToLoad) {
    throw new Error("Assert localeOrLangToLoad is not undefined");
  }
  script = document.createElement('script');
  document.querySelector('head').appendChild(script);
  I18n.debugLog("fetching " + localeOrLangToLoad + " strings for " + project);
  script.addEventListener('load', function() {
    var callbacks, i, len, results;
    script.parentNode.removeChild(script);
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb() : void 0);
    }
    return results;
  }, false);
  script.addEventListener('error', function() {
    var callbacks, i, len, results;
    console.error("I18n error: Error loading language file");
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  }, false);
  return script.src = I18n.buildLocalePath(project, localeOrLangToLoad);
};

I18n.loadLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var callbackAlreadyCalled, check, i, len, project, projects, ref, remaining;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  projects = projectsToLoad != null ? projectsToLoad : I18n.loadedProjects();
  remaining = projects.length;
  callbackAlreadyCalled = false;
  check = function() {
    if (remaining === 0 && callbackAlreadyCalled === false) {
      callbackAlreadyCalled = true;
      return typeof cb === "function" ? cb(locale) : void 0;
    }
  };
  for (i = 0, len = projects.length; i < len; i++) {
    project = projects[i];
    if (shouldLoadLocale && (((ref = I18n.translationsLoaded[project]) != null ? ref[locale] : void 0) == null)) {
      (function(project) {
        var failureCb, successCb;
        return I18n.loadProjectLocale(project, locale, successCb = function(options) {
          if (!(options != null ? options.alreadyPresent : void 0)) {
            I18n.debugLog(locale + " strings loaded dynamically for " + project);
          }
          remaining--;
          return check();
        }, failureCb = function() {
          I18n.debugLog(locale + " strings failed to load for " + project);
          remaining--;
          return check();
        });
      })(project);
    } else {
      I18n.debugLog(locale + " strings already loaded for " + project);
      remaining--;
    }
  }
  return check();
};

I18n.changeLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var deferred, i, len, ref, updateLocaleState, whitelistLocale, whitelisted;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  deferred = new I18n.Promise;
  if (I18n.localeWhitelist instanceof Array) {
    whitelisted = false;
    ref = I18n.localeWhitelist;
    for (i = 0, len = ref.length; i < len; i++) {
      whitelistLocale = ref[i];
      if (locale.indexOf(whitelistLocale) === 0) {
        whitelisted = true;
        break;
      }
    }
    if (!whitelisted) {
      I18n.debugLog("change to " + locale + " prevented by I18n.localeWhitelist: " + I18n.localeWhitelist);
      if (typeof cb === "function") {
        cb(I18n.locale);
      }
      deferred.resolve();
      return deferred;
    }
  }
  updateLocaleState = function(locale) {
    var dateLocale;
    I18n.locale = locale;
    dateLocale = locale;
    if (locale === 'en-ie') {
      dateLocale = 'en-gb';
    }
    if (locale === 'en-in') {
      dateLocale = 'en-au';
    } else if (locale === 'en-nz') {
      dateLocale = 'en-au';
    } else if (locale === 'es-mx') {
      dateLocale = 'es';
    } else if (locale === 'es-ar') {
      dateLocale = 'es-do';
    } else if (locale === 'es-co') {
      dateLocale = 'es-do';
    }
    if (I18n.moment.locale != null) {
      I18n.moment.locale(dateLocale);
    } else {
      I18n.moment.lang(dateLocale);
    }
    I18n.trigger('change:locale', {
      locale: locale
    });
    deferred.resolve();
    return typeof cb === "function" ? cb(locale) : void 0;
  };
  I18n.loadLocale(locale, updateLocaleState, projectsToLoad, shouldLoadLocale);
  return deferred;
};

I18n.changeTimezone = function(timezone) {
  var e, error;
  try {
    I18n.moment.tz(timezone);
  } catch (error) {
    e = error;
    console.error("Error: '" + timezone + "' isn't in our timezone database");
    return;
  }
  I18n.timezone = timezone;
  return I18n.trigger('change:timezone', {
    timezone: timezone
  });
};
}());

(function () {
I18n.langs = {
  en: {
    label: 'English'
  },
  de: {
    label: 'Deutsch'
  },
  ja: {
    label: '日本語'
  },
  es: {
    label: 'Español'
  },
  pt: {
    label: 'Português'
  }
};
}());

(function () {
var availableIn,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

availableIn = ['en'];

I18n.urlPrefix = '';

I18n.locationIn = function(locale) {
  var path, prefixEndsWithSlash, ref, tester, urlPrefix, urlPrefixWithSlash;
  path = document.location.pathname;
  urlPrefix = urlPrefixWithSlash = (ref = I18n.urlPrefix) != null ? ref : '';
  prefixEndsWithSlash = urlPrefix[urlPrefix.length - 1] === "/";
  if (prefixEndsWithSlash) {
    urlPrefix = urlPrefix.substring(0, urlPrefix.length - 1);
  }
  if (urlPrefix) {
    urlPrefixWithSlash = urlPrefix + '/';
  }
  tester = "^/" + urlPrefixWithSlash.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ("(" + (I18n.availableInLocales.join('|')) + ")(/|$)");
  if (new RegExp(tester).test(path)) {
    path = path.substring(3 + urlPrefixWithSlash.length) || '/';
  } else if (urlPrefixWithSlash && new RegExp("^/" + urlPrefixWithSlash).test(path)) {
    path = path.substring(urlPrefixWithSlash.length);
  }
  if (locale === 'en' || indexOf.call(I18n.availableInLocales, locale) < 0) {
    if (urlPrefixWithSlash) {
      return '/' + urlPrefix + path + document.location.search + document.location.hash;
    } else {
      return path + document.location.search + document.location.hash;
    }
  } else {
    return '/' + urlPrefixWithSlash + locale + path + document.location.search + document.location.hash;
  }
};

I18n.availableIn = function(langs, options) {
  if (options == null) {
    options = {};
  }
  availableIn = langs;
  I18n.localeInURL = options.inURL || false;
  return I18n.trigger('change:available', availableIn);
};

if (I18n.availableInLocales == null) {
  Object.defineProperty(I18n, 'availableInLocales', {
    get: function() {
      var ai;
      ai = availableIn.slice(0);
      if (ai.indexOf(I18n.lang) === -1) {
        ai.push(I18n.lang);
      }
      return ai;
    }
  });
}
}());

(function () {
if (typeof window.I18n === 'undefined') {
  window.I18n = {};
}

I18n.setPublicLangPreference = function(lang) {
  var cookieSetterFunc, ref;
  if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    cookieSetterFunc = Cookies.set;
  } else if (typeof window !== "undefined" && window !== null ? (ref = window.jQuery) != null ? ref.cookie : void 0 : void 0) {
    cookieSetterFunc = jQuery.cookie;
  }
  if (cookieSetterFunc != null) {
    return cookieSetterFunc('hubspot.lang.preference', lang, {
      expires: 730,
      path: '/',
      domain: I18n.cookieDomain()
    });
  }
};

I18n.getPublicLangPreference = function() {
  var ref, ref1;
  if (typeof navigator !== "undefined" && navigator !== null ? (ref = navigator.languages) != null ? ref[0] : void 0 : void 0) {
    return navigator.languages[0];
  } else if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    return Cookies.get('hubspot.lang.preference');
  } else if (typeof window !== "undefined" && window !== null ? (ref1 = window.jQuery) != null ? ref1.cookie : void 0 : void 0) {
    return window.jQuery.cookie('hubspot.lang.preference');
  }
};

I18n.cookieDomain = function() {
  if (!window) {
    return;
  }
  return window.location.hostname.split('.').slice(-2).join('.');
};
}());

(function () {
var checkLocaleInURL, getParams;

getParams = (function() {
  var map, query;
  query = location.search.substr(1);
  map = {};
  query.replace(/([^&=]+)=?([^&]*)(?:&+|$)/g, function(match, key, value) {
    return map[key] = value;
  });
  return map;
})();

I18n.manualLocale = getParams.lang || ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_MANUAL_LANG : void 0;
  } catch (undefined) {}
})()) || window.I18N_MANUAL_LANG;

I18n.manualTimezone = ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_TZ : void 0;
  } catch (undefined) {}
})()) || window.I18N_TZ;

if (I18n.manualLocale) {
  I18n.langEnabled = true;
}

if (I18n.manualLocale != null) {
  I18n.debugLog("locale manually set to " + I18n.manualLocale + " (and forcing localeEnabled to true)");
}

if (I18n.manualTimezone != null) {
  I18n.debugLog("timezone manually set to " + I18n.manualTimezone);
}

if (I18n.publicPage && I18n.getPublicLangPreference()) {
  I18n.locale = I18n.getPublicLangPreference();
  I18n.debugLog("initially setting locale to " + I18n.locale + " on public page (via cookie)");
} else {
  I18n.locale = I18n.manualLocale || window.I18N_RENDERED_LANG || I18n.locale || (typeof navigator !== "undefined" && navigator !== null ? navigator.language : void 0) || (typeof navigator !== "undefined" && navigator !== null ? navigator.userLanguage : void 0) || 'en';
  if (I18n.locale.indexOf('_') >= 0) {
    I18n.locale = I18n.locale.replace('_', '-');
  }
  if (typeof I18n.locale === 'string' && I18n.locale.substring(0, 2) === 'pt') {
    I18n.locale = 'pt-br';
  } else if (I18n.locale === 'noNO' || I18n.locale === 'no') {
    I18n.locale = 'no-no';
  } else if (I18n.locale === 'zh-tw') {
    I18n.locale = 'zh-hk';
  } else if (I18n.locale === 'es-co') {
    I18n.locale = 'es-ar';
  } else if (I18n.locale === 'ar') {
    I18n.locale = 'ar-eg';
  } else if (I18n.locale === 'ca') {
    I18n.locale = 'ca-es';
  }
  I18n.debugLog("initially setting locale to " + I18n.locale);
}

I18n.timezone = I18n.manualTimezone || window.I18N_RENDERED_TZ || I18n.timezone || 'US/Eastern';

I18n.debugLog("initially setting timezone to " + I18n.timezone);

(checkLocaleInURL = function() {
  if (I18n.localeInURL) {
    if (!window.I18N_RENDERED_LANG) {
      console.error("I18N_RENDERED_LANG not found, are we rendering with Schablone and inheriting from the base template (w/ StyleGuideUI v2)?");
      return;
    }
    if (window.I18N_RENDERED_LANG !== I18n.lang) {
      I18n.debugLog("changing locale " + I18n.lang + " via checkLocaleInURL");
      return I18n.changeLocale(I18n.lang);
    }
  }
})();

I18n.on('change:available', checkLocaleInURL);

if (I18n.moment) {
  if (I18n.moment.locale != null) {
    I18n.moment.locale(I18n.locale);
  } else {
    I18n.moment.lang(I18n.locale);
  }
}
}());

(function () {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

hubspot.defineEager('hubspot.I18n.load', ['hubspot.carmen.client', 'hubspot.PortalIdParser'], function(Carmen, PortalIdParser) {
  var load;
  load = function(pid, loadLocaleFallback) {
    var portalID;
    portalID = pid || PortalIdParser.get({
      preserveGlobalId: true
    });
    if (!portalID || I18n.manualLocale) {
      I18n.trigger('locale:noop');
    }
    if (!portalID || I18n.manualTimezone) {
      I18n.trigger('timezone:noop');
    }
    if (!portalID) {
      return;
    }
    if (pid) {
      Carmen.setPortalIdIfNotAvailable(portalID);
    }
    return Carmen.load(function(arg) {
      var langEnabled, locale, ref, timezone;
      locale = arg.locale, timezone = arg.timezone, langEnabled = arg.langEnabled;
      I18n.debugLog("Carmen response: locale = " + locale + "  timezone = " + timezone + "  langEnabled = " + langEnabled);
      locale || (locale = I18n.locale);
      if (I18n.publicPage) {
        I18n.debugLog("Forcing langEnabled to true for public page");
        langEnabled = true;
        if (I18n.getPublicLangPreference() && I18n.availableInLocales && (ref = I18n.getPublicLangPreference, indexOf.call(I18n.availableInLocales, ref) >= 0)) {
          I18n.debugLog("setting locale from public lang preference");
          locale = I18n.getPublicLangPreference();
        } else if (I18N_RENDERED_LANG) {
          I18n.debugLog("setting locale from I18N_RENDERED_LANG on public page");
          locale = I18N_RENDERED_LANG;
        }
      }
      if (!I18n.manualLocale) {
        if (indexOf.call(I18n.availableInLocales, locale) >= 0 || !I18n.publicPage) {
          I18n.langEnabled = langEnabled;
          I18n.debugLog("Lang enabled: " + langEnabled);
          I18n.debugLog(locale + " is available locale, changing...");
          I18n.changeLocale(locale, null, null, I18n.langEnabled).then(function(locale) {
            I18n.trigger('locale:loaded', {
              locale: locale
            });
            if (pid) {
              return I18n.trigger('readyWithPortalId');
            }
          }, function() {
            return I18n.trigger('locale:failed');
          });
        }
      }
      if (I18n.publicPage && !I18n.manualTimezone) {
        if (timezone) {
          I18n.changeTimezone(timezone);
          return I18n.trigger('timezone:loaded', {
            timezone: timezone
          });
        } else {
          return I18n.trigger('timezone:loaded');
        }
      }
    }, function() {
      console.error("Error loading locale/timezone");
      I18n.trigger('locale:failed');
      return I18n.trigger('timezone:failed');
    }, loadLocaleFallback);
  };
  load();
  return load;
});
}());

(function () {
var updateClass;

updateClass = function() {
  var html;
  html = document.querySelector('html');
  html.className = html.className.replace(/(^|\b)lang-[a-z]{2}($|\b)/, '');
  html.className += " lang-" + I18n.lang;
  return html.setAttribute('lang', I18n.locale);
};

I18n.whenDOMContentLoaded(updateClass);

I18n.on('change:locale', updateClass);
}());

(function () {
I18n.on('change:locale', function() {
  var el, elements, i, len, results;
  try {
    if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_SHOW_KEYS : void 0) === 'true') {
      elements = document.querySelectorAll('i18n-string');
      if (elements != null) {
        results = [];
        for (i = 0, len = elements.length; i < len; i++) {
          el = elements[i];
          results.push(el.innerHTML = I18n.html(el.getAttribute('data-key'), JSON.parse(el.getAttribute('data-options'))));
        }
        return results;
      }
    }
  } catch (undefined) {}
});
}());

(function () {
I18n.title = function(key, options) {
  if (typeof document !== "undefined" && document !== null) {
    I18n.when('ready', function() {
      return document.title = I18n.text(key, options);
    });
    return '';
  } else {
    return I18n.text(key, options);
  }
};
}());

(function () {
var debugSetting, debugString, i18nDebugEnabled, ref;

debugSetting = void 0;

debugString = ("" + ((function() {
  if ((ref = window.I18N_DEBUG) != null) {
    return ref;
  } else {
    try {
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_DEBUG : void 0;
    } catch (undefined) {}
  }
})())).toLowerCase();

if (debugString === 'true' || debugString === 'false') {
  debugSetting = debugString === 'true';
}

if (debugSetting === false) {
  i18nDebugEnabled = false;
} else {
  i18nDebugEnabled = debugSetting;
}

if (i18nDebugEnabled) {
  I18n.showDebugTools = true;
  window.addEventListener('load', function() {
    var script, style;
    script = document.createElement('script');
    script.src = I18n.buildStaticPath('I18n', '/bundles/debug.js');
    document.querySelector('head').appendChild(script);
    style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', I18n.buildStaticPath('I18n', '/bundles/debug.css'));
    return document.querySelector('head').appendChild(style);
  }, false);
}
}());

(function () {

}());


(function() {
  var module = {};
  var result = {};
  module.exports = { "af": { "i18n": { "duration": { "seconds": "{{ seconds }} sekondes", "minutes": "{{ minutes }} minute", "hours": "{{ hours }} ure", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dae ", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u{{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan.", "february": "Feb.", "march": "Mrt.", "april": "Apr.", "may": "Mei", "june": "Jun.", "july": "Jul.", "august": "Aug.", "september": "Sep.", "october": "Okt.", "november": "Nov.", "december": "Des." } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}} ", "quarterAndYear": "{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, uitbr. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "af": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:af', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ar-eg": { "i18n": { "duration": { "seconds": "{{ seconds }} ثانية", "minutes": "{{ minutes }} دقيقة", "hours": "{{ hours }} ساعة", "hoursAndMinutes": "{{ hours }} ساعة {{ minutes }} دقيقة", "days": "{{ days }} أيام", "shortForm": { "seconds": "{{ seconds }} ث", "minutes": "{{ minutes }} د", "hours": "{{ hours }} س", "days": "{{ days }} ي", "hoursAndMinutes": "{{ hours }} س {{ minutes }} د" } }, "dateTime": { "shortForm": { "months": { "january": "يناير", "february": "فبراير", "march": "مارس", "april": "أبريل", "may": "مايو", "june": "يونيو", "july": "يوليو", "august": "أغسطس", "september": "سبتمبر", "october": "أكتوبر", "november": "نوفمبر", "december": "ديسمبر" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}،{{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}، تمديد {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ar-eg": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ar-eg', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} сек", "minutes": "{{ minutes }} мин", "hours": "{{ hours }} ч", "hoursAndMinutes": "{{ hours }} ч {{ minutes }} мин", "days": "{{ days }} дни", "shortForm": { "seconds": "{{ seconds }} сек", "minutes": "{{ minutes }} мин", "hours": "{{ hours }} ч", "days": "{{ days }} д", "hoursAndMinutes": "{{ hours }} ч {{ minutes }} мин" } }, "dateTime": { "shortForm": { "months": { "january": "Яну", "february": "Фев", "march": "Мар", "april": "Апр", "may": "Май", "june": "Юни", "july": "Юли", "august": "Авг", "september": "Сеп", "october": "Окт", "november": "Ное", "december": "Дек" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, вътр. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "bn": { "i18n": { "duration": { "seconds": "{{ seconds }}সেক", "minutes": "{{ minutes }}মিনিট", "hours": "{{ hours }}ঘন্টা", "hoursAndMinutes": "{{ hours }}ঘন্টা {{ minutes }}মিনিট", "days": "{{ days }}দিন ", "shortForm": { "seconds": "{{ seconds }}সে", "minutes": "{{ minutes }}মি ", "hours": "{{ hours }}ঘ", "days": "{{ days }}দি ", "hoursAndMinutes": "{{ hours }}ঘ {{ minutes }}মি" } }, "dateTime": { "shortForm": { "months": { "january": "জানুয়ারি", "february": "ফেব্রুয়ারি", "march": "মার্চ", "april": "এপ্রিল", "may": "মে", "june": "জুন", "july": "জুলাই", "august": "আগস্ট", "september": "সেপ্টেম্বর", "october": "অক্টোবর", "november": "নভেম্বর", "december": "ডিসেম্বর" } }, "monthAndDay": "{{dayNumber}}{{monthName}}", "monthAndYear": "{{monthName}}{{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}},{{fullDate}}", "quarterAndYear": "Q{{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}},এক্সট.{{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "bn": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bn', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ca-es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dies", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "shortForm": { "months": { "january": "Gen.", "february": "Febr.", "march": "Març", "april": "Abr.", "may": "Maig", "june": "Juny", "july": "Jul.", "august": "Ag.", "september": "Set.", "october": "Oct.", "november": "Nov.", "december": "Des." } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ca-es": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ca-es', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "cs": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hod", "hoursAndMinutes": "{{ hours }} hod {{ minutes }} min", "days": "{{ days }} d", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "shortForm": { "months": { "january": "led", "february": "úno", "march": "bře", "april": "dub", "may": "kvě", "june": "čvn", "july": "čvc", "august": "srp", "september": "zář", "october": "říj", "november": "lis", "december": "pro" } }, "monthAndDay": "{{dayNumber}}. {{monthName}} ", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}} {{fullDate}}", "quarterAndYear": "Q {{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, linka {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "cs": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:cs', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Maj", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}}{{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lokal {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mrz", "april": "Apr", "may": "Mai", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dez" } }, "monthAndDay": "{{dayNumber}}. {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, Durchwahl {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} δευτ.", "minutes": "{{ minutes }} λεπτ.", "hours": "{{ hours }} ώρ.", "hoursAndMinutes": "{{ hours }} ώρ. {{ minutes }} λεπτ.", "days": "{{ days }} ημέρες", "shortForm": { "seconds": "{{ seconds }}δ.", "minutes": "{{ minutes }}λ.", "hours": "{{ hours }}ώρ.", "days": "{{ days }}ημ.", "hoursAndMinutes": "{{ hours }}ώρ. {{ minutes }}λ." } }, "dateTime": { "shortForm": { "months": { "january": "Ιαν", "february": "Φεβ", "march": "Μάρ", "april": "Απρ", "may": "Μάι", "june": "Ιούν", "july": "Ιούλ", "august": "Αύγ", "september": "Σεπ", "october": "Οκτ", "november": "Νοέ", "december": "Δεκ" } }, "monthAndDay": "{{dayNumber}}{{monthName}} ", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "{{quarterNumber}}ο τρίμ. {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, εσωτ. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} días", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "ene", "february": "feb", "march": "mar", "april": "abr", "may": "mayo", "june": "jun", "july": "jul", "august": "ago", "september": "sep", "october": "oct", "november": "nov", "december": "dic" } }, "monthAndDay": "{{dayNumber}} de {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} seg", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} días", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "ene", "february": "feb", "march": "mar", "april": "abr", "may": "may", "june": "jun", "july": "jul", "august": "ago", "september": "sep", "october": "oct", "november": "nov", "december": "dic" } }, "monthAndDay": "{{dayNumber}} de {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "shortForm": { "months": { "january": "Tammi", "february": "Helmi", "march": "Maalis", "april": "Huhti", "may": "Toukokuu", "june": "Kesä", "july": "Heinä", "august": "Elo", "september": "Syys", "october": "Loka", "november": "Marras", "december": "Joulu" } }, "monthAndDay": "{{monthName}} {{dayNumber}}.", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} jours", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} j", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "shortForm": { "months": { "january": "jan", "february": "fév", "march": "mar", "april": "avr", "may": "mai", "june": "juin", "july": "juil", "august": "août", "september": "sep", "october": "oct", "november": "nov", "december": "déc" } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "hr": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dana", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Sij.", "february": "Velj", "march": "Ožuj.", "april": "Trav.", "may": "Svib.", "june": "Lip.", "july": "Srp.", "august": "Kol.", "september": "Ruj.", "october": "List.", "november": "Stud.", "december": "Pros." } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}.", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lok. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "hr": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hr', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "hu": { "i18n": { "duration": { "seconds": "{{ seconds }} mp.", "minutes": "{{ minutes }} p.", "hours": "{{ hours }} ó.", "hoursAndMinutes": "{{ hours }} ó. {{ minutes }} p.", "days": "{{ days }} nap", "shortForm": { "seconds": "{{ seconds }} mp", "minutes": "{{ minutes }} p", "hours": "{{ hours }} ó", "days": "{{ days }} n", "hoursAndMinutes": "{{ hours }} ó {{ minutes }} p" } }, "dateTime": { "shortForm": { "months": { "january": "jan", "february": "feb", "march": "már", "april": "ápr", "may": "máj", "june": "jún", "july": "júl", "august": "aug", "september": "szep", "october": "okt", "november": "nov", "december": "dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}.", "monthAndYear": "{{yearNumber}}. {{monthName}}", "weekDayAndMonthAndDayAndYear": "{{fullDate}}, {{weekDay}}", "quarterAndYear": "{{yearNumber}}. {{quarterNumber}}. né." }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, {{extension}} mellék" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "hu": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hu', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "id": { "i18n": { "duration": { "seconds": "{{ seconds }} dtk", "minutes": "{{ minutes }}  mnt", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} mnt", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}d", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Mei", "june": "Jun", "july": "Jul", "august": "Ags", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Des" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "id": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:id', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Gen", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Mag", "june": "Giu", "july": "Lug", "august": "Ago", "september": "Set", "october": "Ott", "november": "Nov", "december": "Dic" } }, "monthAndDay": "{{dayNumber}}{{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分", "days": "{{ days }}日", "shortForm": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "days": "{{ days }}日", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分" } }, "dateTime": { "shortForm": { "months": { "january": "1月", "february": "2月", "march": "3月", "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月", "september": "9月", "october": "10月", "november": "11月", "december": "12月" } }, "monthAndDay": "{{monthName}}{{dayNumber}}日", "monthAndYear": "{{yearNumber}}年{{monthName}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}、{{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}、内線番号{{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분", "days": "{{ days }}일", "shortForm": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "days": "{{ days }}일", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분" } }, "dateTime": { "shortForm": { "months": { "january": "1월", "february": "2월", "march": "3월", "april": "4월", "may": "5월", "june": "6월", "july": "7월", "august": "8월", "september": "9월", "october": "10월", "november": "11월", "december": "12월" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{yearNumber}} {{monthName}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "{{yearNumber}} {{quarterNumber}}분기" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, 내선번호: {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "nl": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dagen", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mrt", "april": "Apr", "may": "Mei", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}} {{fullDate}}", "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "nl": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:nl', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "no-no": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tm", "hoursAndMinutes": "{{ hours }} tm {{ minutes }} min", "days": "{{ days }} dager", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}t", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}t {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "mai", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Des" } }, "monthAndDay": "{{dayNumber}}. {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, utvidelse {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "no": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:no', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "shortForm": { "months": { "january": "styczeń", "february": "luty", "march": "marzec", "april": "kwiecień", "may": "maj", "june": "czerwiec", "july": "lipiec", "august": "sierpień", "september": "wrzesień", "october": "październik", "november": "listopad", "december": "grudzień" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, rozsz. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Fev", "march": "Mar", "april": "Abr", "may": "Maio", "june": "Jun", "july": "Jul", "august": "Ago", "september": "Set", "october": "Out", "november": "Nov", "december": "Dez" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ramal {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ro": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "days": "{{ days }} zile", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}z", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Ian", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Mai", "june": "Iun", "july": "Iul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ru": { "i18n": { "duration": { "seconds": "{{ seconds }} с", "minutes": "{{ minutes }} мин", "hours": "{{ hours }} ч", "hoursAndMinutes": "{{ hours }} ч {{ minutes }} мин", "days": "{{ days }} дн.", "shortForm": { "seconds": "{{ seconds }}с", "minutes": "{{ minutes }}м", "hours": "{{ hours }}ч", "days": "{{ days }}д", "hoursAndMinutes": "{{ hours }}ч {{ minutes }}м" } }, "dateTime": { "shortForm": { "months": { "january": "Янв", "february": "Фев", "march": "Мар", "april": "Апр", "may": "Май", "june": "Июн", "july": "Июл", "august": "Авг", "september": "Сен", "october": "Окт", "november": "Ноя", "december": "Дек" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Кв.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, добав. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ru": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ru', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Maj", "june": "Jun", "july": "Jul", "august": "Avg", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "shortForm": { "months": { "january": "jan", "february": "feb", "march": "mar", "april": "apr", "may": "maj", "june": "jun", "july": "jul", "august": "aug", "september": "sep", "october": "okt", "november": "nov", "december": "dec" } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "F{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, anknytning {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "th": { "i18n": { "duration": { "seconds": "{{ seconds }} วินาที", "minutes": "{{ minutes }} นาที", "hours": "{{ hours }} ชั่วโมง", "hoursAndMinutes": "{{ hours }} ชั่วโมง {{ minutes }} นาที", "days": "{{ days }} วัน", "shortForm": { "seconds": "{{ seconds }} วินาที", "minutes": "{{ minutes }} นาที", "hours": "{{ hours }} ชม.", "days": "{{ days }} วัน", "hoursAndMinutes": "{{ hours }} ชม. {{ minutes }} นาที" } }, "dateTime": { "shortForm": { "months": { "january": "ม.ค.", "february": "ก.พ.", "march": "มี.ค.", "april": "เม.ย.", "may": "พ.ค.", "june": "มิ.ย.", "july": "ก.ค.", "august": "ส.ค.", "september": "ก.ย.", "october": "ต.ค.", "november": "พ.ย.", "december": "ธ.ค." } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}} {{fullDate}}", "quarterAndYear": "ไตรมาส {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}} ต่อ {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "th": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:th', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "tr": { "i18n": { "duration": { "seconds": "{{ seconds }} sn.", "minutes": "{{ minutes }} dk.", "hours": "{{ hours }} sa.", "hoursAndMinutes": "{{ hours }} sa. {{ minutes }} dk.", "days": "{{ days }} gün", "shortForm": { "seconds": "{{ seconds }}sn.", "minutes": "{{ minutes }}dk.", "hours": "{{ hours }}sa.", "days": "{{ days }}gün", "hoursAndMinutes": "{{ hours }}sa. {{ minutes }}dk." } }, "dateTime": { "shortForm": { "months": { "january": "Oca", "february": "Şub", "march": "Mar", "april": "Nis", "may": "May", "june": "Haz", "july": "Tem", "august": "Ağu", "september": "Eyl", "october": "Eki", "november": "Kas", "december": "Ara" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "{{quarterNumber}}. Ç {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, dahili {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "tr": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:tr', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "uk": { "i18n": { "duration": { "seconds": "{{ seconds }} секунд", "minutes": "{{ minutes }} хвилин", "hours": "{{ hours }} годин", "hoursAndMinutes": "{{ hours }} годин {{ minutes }} хвилин", "days": "{{ days }} днів", "shortForm": { "seconds": "{{ seconds }}с", "minutes": "{{ minutes }}хв", "hours": "{{ hours }}год", "days": "{{ days }}д", "hoursAndMinutes": "{{ hours }}год {{ minutes }}хв" } }, "dateTime": { "shortForm": { "months": { "january": "Січень", "february": "Лютий", "march": "Березень", "april": "Квітень", "may": "Травень", "june": "Червень", "july": "Липень", "august": "Серпень", "september": "Вересень", "october": "Жовтень", "november": "Листопад", "december": "Грудень" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Кв.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, дод. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "uk": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:uk', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "vi": { "i18n": { "duration": { "seconds": "{{ seconds }} giây", "minutes": "{{ minutes }} phút", "hours": "{{ hours }} giờ", "hoursAndMinutes": "{{ hours }} giờ {{ minutes }} phút", "days": "{{ days }} ngày", "shortForm": { "seconds": "{{ seconds }} giây", "minutes": "{{ minutes }} phút", "hours": "{{ hours }} giờ", "days": "{{ days }} ngày", "hoursAndMinutes": "{{ hours }} giờ {{ minutes }} phút" } }, "dateTime": { "shortForm": { "months": { "january": "Thg1", "february": "Thg2", "march": "Thg3", "april": "Thg4", "may": "Thg5", "june": "Thg6", "july": "Thg7", "august": "Thg8", "september": "Thg9", "october": "Thg10", "november": "Thg11", "december": "Thg12" } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, máy lẻ {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "vi": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:vi', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟", "days": "{{ days }} 天", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "days": "{{ days }} 天", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟" } }, "dateTime": { "shortForm": { "months": { "january": "1  月", "february": "2 月", "march": "3 月", "april": "4 月", "may": "5 月", "june": "6 月", "july": "7 月", "august": "8 月", "september": "9 月", "october": "10 月", "november": "11 月", "december": "12 月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日", "monthAndYear": " {{yearNumber}} 年 {{monthName}}", "weekDayAndMonthAndDayAndYear": "{{fullDate}}（ {{weekDay}}）", "quarterAndYear": "{{yearNumber}} 年第 {{quarterNumber}} 季度" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}，分机 {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.606'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分鐘", "hours": "{{ hours }} 小時", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分鐘", "days": "{{ days }} 日", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分", "hours": "{{ hours }} 小時", "days": "{{ days }} 日", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分" } }, "dateTime": { "shortForm": { "months": { "january": "1月", "february": "2月", "march": "3月", "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月", "september": "9月", "october": "10月", "november": "11月", "december": "12月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日 ", "monthAndYear": "{{yearNumber}} 年 {{monthName}}", "weekDayAndMonthAndDayAndYear": "{{fullDate}}{{weekDay}}", "quarterAndYear": "{{yearNumber}} 年第 {{quarterNumber}} 季 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.606"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.606",
    "ar-eg": "static-7.606",
    "bg": "static-7.606",
    "bn": "static-7.606",
    "ca-es": "static-7.606",
    "cs": "static-7.606",
    "da": "static-7.606",
    "de": "static-7.606",
    "el": "static-7.606",
    "en": "static-7.606",
    "es-mx": "static-7.606",
    "es": "static-7.606",
    "fi": "static-7.606",
    "fr": "static-7.606",
    "hr": "static-7.606",
    "hu": "static-7.606",
    "id": "static-7.606",
    "it": "static-7.606",
    "ja": "static-7.606",
    "ko": "static-7.606",
    "nl": "static-7.606",
    "no": "static-7.606",
    "pl": "static-7.606",
    "pt-br": "static-7.606",
    "ro": "static-7.606",
    "ru": "static-7.606",
    "sl": "static-7.606",
    "sv": "static-7.606",
    "th": "static-7.606",
    "tr": "static-7.606",
    "uk": "static-7.606",
    "vi": "static-7.606",
    "zh-cn": "static-7.606",
    "zh-hk": "static-7.606"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.606'}); }
})();


//! moment-timezone.js
//! version : 0.5.32
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.32",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


(function () {
var earlyAuthRequest, ref, setupTimezone, timezoneAlreadySetup;

timezoneAlreadySetup = false;

setupTimezone = function(arg) {
  var e, error, portal;
  portal = arg.portal;
  if (I18n.manualTimezone) {
    return;
  }
  if (timezoneAlreadySetup === true) {
    return;
  }
  try {
    if ((portal != null ? portal.timezone : void 0) && portal.timezone.id && portal.timezone['moment-data']) {
      timezoneAlreadySetup = true;
      if (!I18n.moment.tz.zone(portal.timezone.id)) {
        I18n.moment.tz.add(portal.timezone.id + "|" + portal.timezone['moment-data']);
      }
      I18n.changeTimezone(portal.timezone.id);
      return I18n.trigger('timezone:loaded');
    } else {
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureMessage("I18n failed to parse api-verify data: " + JSON.stringify(portal != null ? portal.timezone : void 0)) : void 0;
    }
  } catch (error) {
    e = error;
    console.error('Error timezone thing', e);
    return typeof Raven !== "undefined" && Raven !== null ? Raven.captureException(e) : void 0;
  }
};

earlyAuthRequest = (ref = window.quickFetch) != null ? ref.getRequestStateByName('api-verify') : void 0;

if (earlyAuthRequest != null) {
  earlyAuthRequest.whenFinished((function(_this) {
    return function(loginVerifyData) {
      return setupTimezone(loginVerifyData);
    };
  })(this));
}

window.addEventListener('hubspot:userinfochange', function(e) {
  return setupTimezone(e);
});
}());




// Include all externalized strings


// We expect moment-timezone data to be provided at runtime


//  Needs to come after moment-timezone



